(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebaaf"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebaaf"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bhrDl", function(module, exports) {

$parcel$export(module.exports, "ElementObserver", function () { return $8366b7adf73549a0$export$12e07a2a9f87578a; });
$parcel$export(module.exports, "AttributeObserver", function () { return $8366b7adf73549a0$export$fe68319d413d05cb; });
$parcel$export(module.exports, "add", function () { return $8366b7adf73549a0$export$e16d8520af44a096; });
$parcel$export(module.exports, "fetch", function () { return $8366b7adf73549a0$export$e7aa7bc5c1b3cfb3; });
$parcel$export(module.exports, "del", function () { return $8366b7adf73549a0$export$1d2f21e549771e67; });
$parcel$export(module.exports, "prune", function () { return $8366b7adf73549a0$export$d6cf75919f12ca5a; });
$parcel$export(module.exports, "Multimap", function () { return $8366b7adf73549a0$export$8bd4ad37b76db6ba; });
$parcel$export(module.exports, "IndexedMultimap", function () { return $8366b7adf73549a0$export$a7c3d2c2552a674d; });
$parcel$export(module.exports, "SelectorObserver", function () { return $8366b7adf73549a0$export$116e0b48509995b; });
$parcel$export(module.exports, "StringMapObserver", function () { return $8366b7adf73549a0$export$da226bebbf7f6caa; });
$parcel$export(module.exports, "TokenListObserver", function () { return $8366b7adf73549a0$export$3aa21c2f03ef6b3b; });
$parcel$export(module.exports, "ValueListObserver", function () { return $8366b7adf73549a0$export$d27fa4c7330a452e; });
$parcel$export(module.exports, "Context", function () { return $8366b7adf73549a0$export$841858b892ce1f4c; });
$parcel$export(module.exports, "defaultSchema", function () { return $8366b7adf73549a0$export$1db618b7b2275ea1; });
$parcel$export(module.exports, "Application", function () { return $8366b7adf73549a0$export$16975c34e60e1e61; });
$parcel$export(module.exports, "Controller", function () { return $8366b7adf73549a0$export$bd0bf19f25da8474; });
/*
Stimulus 3.2.1
Copyright © 2023 Basecamp, LLC
 */ 
var $jpnpo = parcelRequire("jpnpo");

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $Npnks = parcelRequire("Npnks");

var $15W2b = parcelRequire("15W2b");

var $711He = parcelRequire("711He");

var $i0LXg = parcelRequire("i0LXg");

var $fyOZQ = parcelRequire("fyOZQ");

var $enL5v = parcelRequire("enL5v");

var $jquDQ = parcelRequire("jquDQ");

var $a1vXf = parcelRequire("a1vXf");

var $itJXR = parcelRequire("itJXR");
var $8366b7adf73549a0$var$EventListener = /*#__PURE__*/ function() {
    "use strict";
    function EventListener(eventTarget, eventName, eventOptions) {
        (0, $9j09T._)(this, EventListener);
        this.eventTarget = eventTarget;
        this.eventName = eventName;
        this.eventOptions = eventOptions;
        this.unorderedBindings = new Set();
    }
    (0, $eDeHT._)(EventListener, [
        {
            key: "connect",
            value: function connect() {
                this.eventTarget.addEventListener(this.eventName, this, this.eventOptions);
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                this.eventTarget.removeEventListener(this.eventName, this, this.eventOptions);
            }
        },
        {
            key: "bindingConnected",
            value: function bindingConnected(binding) {
                this.unorderedBindings.add(binding);
            }
        },
        {
            key: "bindingDisconnected",
            value: function bindingDisconnected(binding) {
                this.unorderedBindings.delete(binding);
            }
        },
        {
            key: "handleEvent",
            value: function handleEvent(event) {
                var extendedEvent = $8366b7adf73549a0$var$extendEvent(event);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.bindings[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var binding = _step.value;
                        if (extendedEvent.immediatePropagationStopped) break;
                        else binding.handleEvent(extendedEvent);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "hasBindings",
            value: function hasBindings() {
                return this.unorderedBindings.size > 0;
            }
        },
        {
            key: "bindings",
            get: function get() {
                return Array.from(this.unorderedBindings).sort(function(left, right) {
                    var leftIndex = left.index, rightIndex = right.index;
                    return leftIndex < rightIndex ? -1 : leftIndex > rightIndex ? 1 : 0;
                });
            }
        }
    ]);
    return EventListener;
}();
function $8366b7adf73549a0$var$extendEvent(event) {
    if ("immediatePropagationStopped" in event) return event;
    else {
        var stopImmediatePropagation = event.stopImmediatePropagation;
        return Object.assign(event, {
            immediatePropagationStopped: false,
            stopImmediatePropagation: function() {
                this.immediatePropagationStopped = true;
                stopImmediatePropagation.call(this);
            }
        });
    }
}
var $8366b7adf73549a0$var$Dispatcher = /*#__PURE__*/ function() {
    "use strict";
    function Dispatcher(application) {
        (0, $9j09T._)(this, Dispatcher);
        this.application = application;
        this.eventListenerMaps = new Map();
        this.started = false;
    }
    (0, $eDeHT._)(Dispatcher, [
        {
            key: "start",
            value: function start() {
                if (!this.started) {
                    this.started = true;
                    this.eventListeners.forEach(function(eventListener) {
                        return eventListener.connect();
                    });
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.started) {
                    this.started = false;
                    this.eventListeners.forEach(function(eventListener) {
                        return eventListener.disconnect();
                    });
                }
            }
        },
        {
            key: "eventListeners",
            get: function get() {
                return Array.from(this.eventListenerMaps.values()).reduce(function(listeners, map) {
                    return listeners.concat(Array.from(map.values()));
                }, []);
            }
        },
        {
            key: "bindingConnected",
            value: function bindingConnected(binding) {
                this.fetchEventListenerForBinding(binding).bindingConnected(binding);
            }
        },
        {
            key: "bindingDisconnected",
            value: function bindingDisconnected(binding) {
                var clearEventListeners = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                this.fetchEventListenerForBinding(binding).bindingDisconnected(binding);
                if (clearEventListeners) this.clearEventListenersForBinding(binding);
            }
        },
        {
            key: "handleError",
            value: function handleError(error, message) {
                var detail = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                this.application.handleError(error, "Error ".concat(message), detail);
            }
        },
        {
            key: "clearEventListenersForBinding",
            value: function clearEventListenersForBinding(binding) {
                var eventListener = this.fetchEventListenerForBinding(binding);
                if (!eventListener.hasBindings()) {
                    eventListener.disconnect();
                    this.removeMappedEventListenerFor(binding);
                }
            }
        },
        {
            key: "removeMappedEventListenerFor",
            value: function removeMappedEventListenerFor(binding) {
                var eventTarget = binding.eventTarget, eventName = binding.eventName, eventOptions = binding.eventOptions;
                var eventListenerMap = this.fetchEventListenerMapForEventTarget(eventTarget);
                var cacheKey = this.cacheKey(eventName, eventOptions);
                eventListenerMap.delete(cacheKey);
                if (eventListenerMap.size == 0) this.eventListenerMaps.delete(eventTarget);
            }
        },
        {
            key: "fetchEventListenerForBinding",
            value: function fetchEventListenerForBinding(binding) {
                var eventTarget = binding.eventTarget, eventName = binding.eventName, eventOptions = binding.eventOptions;
                return this.fetchEventListener(eventTarget, eventName, eventOptions);
            }
        },
        {
            key: "fetchEventListener",
            value: function fetchEventListener(eventTarget, eventName, eventOptions) {
                var eventListenerMap = this.fetchEventListenerMapForEventTarget(eventTarget);
                var cacheKey = this.cacheKey(eventName, eventOptions);
                var eventListener = eventListenerMap.get(cacheKey);
                if (!eventListener) {
                    eventListener = this.createEventListener(eventTarget, eventName, eventOptions);
                    eventListenerMap.set(cacheKey, eventListener);
                }
                return eventListener;
            }
        },
        {
            key: "createEventListener",
            value: function createEventListener(eventTarget, eventName, eventOptions) {
                var eventListener = new $8366b7adf73549a0$var$EventListener(eventTarget, eventName, eventOptions);
                if (this.started) eventListener.connect();
                return eventListener;
            }
        },
        {
            key: "fetchEventListenerMapForEventTarget",
            value: function fetchEventListenerMapForEventTarget(eventTarget) {
                var eventListenerMap = this.eventListenerMaps.get(eventTarget);
                if (!eventListenerMap) {
                    eventListenerMap = new Map();
                    this.eventListenerMaps.set(eventTarget, eventListenerMap);
                }
                return eventListenerMap;
            }
        },
        {
            key: "cacheKey",
            value: function cacheKey(eventName, eventOptions) {
                var parts = [
                    eventName
                ];
                Object.keys(eventOptions).sort().forEach(function(key) {
                    parts.push("".concat(eventOptions[key] ? "" : "!").concat(key));
                });
                return parts.join(":");
            }
        }
    ]);
    return Dispatcher;
}();
var $8366b7adf73549a0$var$defaultActionDescriptorFilters = {
    stop: function(param) {
        var event = param.event, value = param.value;
        if (value) event.stopPropagation();
        return true;
    },
    prevent: function(param) {
        var event = param.event, value = param.value;
        if (value) event.preventDefault();
        return true;
    },
    self: function(param) {
        var event = param.event, value = param.value, element = param.element;
        if (value) return element === event.target;
        else return true;
    }
};
var $8366b7adf73549a0$var$descriptorPattern = /^(?:(?:([^.]+?)\+)?(.+?)(?:\.(.+?))?(?:@(window|document))?->)?(.+?)(?:#([^:]+?))(?::(.+))?$/;
function $8366b7adf73549a0$var$parseActionDescriptorString(descriptorString) {
    var source = descriptorString.trim();
    var matches = source.match($8366b7adf73549a0$var$descriptorPattern) || [];
    var eventName = matches[2];
    var keyFilter = matches[3];
    if (keyFilter && ![
        "keydown",
        "keyup",
        "keypress"
    ].includes(eventName)) {
        eventName += ".".concat(keyFilter);
        keyFilter = "";
    }
    return {
        eventTarget: $8366b7adf73549a0$var$parseEventTarget(matches[4]),
        eventName: eventName,
        eventOptions: matches[7] ? $8366b7adf73549a0$var$parseEventOptions(matches[7]) : {},
        identifier: matches[5],
        methodName: matches[6],
        keyFilter: matches[1] || keyFilter
    };
}
function $8366b7adf73549a0$var$parseEventTarget(eventTargetName) {
    if (eventTargetName == "window") return window;
    else if (eventTargetName == "document") return document;
}
function $8366b7adf73549a0$var$parseEventOptions(eventOptions) {
    return eventOptions.split(":").reduce(function(options, token) {
        return Object.assign(options, (0, $Npnks._)({}, token.replace(/^!/, ""), !/^!/.test(token)));
    }, {});
}
function $8366b7adf73549a0$var$stringifyEventTarget(eventTarget) {
    if (eventTarget == window) return "window";
    else if (eventTarget == document) return "document";
}
function $8366b7adf73549a0$var$camelize(value) {
    return value.replace(/(?:[_-])([a-z0-9])/g, function(_, char) {
        return char.toUpperCase();
    });
}
function $8366b7adf73549a0$var$namespaceCamelize(value) {
    return $8366b7adf73549a0$var$camelize(value.replace(/--/g, "-").replace(/__/g, "_"));
}
function $8366b7adf73549a0$var$capitalize(value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
}
function $8366b7adf73549a0$var$dasherize(value) {
    return value.replace(/([A-Z])/g, function(_, char) {
        return "-".concat(char.toLowerCase());
    });
}
function $8366b7adf73549a0$var$tokenize(value) {
    return value.match(/[^\s]+/g) || [];
}
function $8366b7adf73549a0$var$isSomething(object) {
    return object !== null && object !== undefined;
}
function $8366b7adf73549a0$var$hasProperty(object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
}
var $8366b7adf73549a0$var$allModifiers = [
    "meta",
    "ctrl",
    "alt",
    "shift"
];
var $8366b7adf73549a0$var$Action = /*#__PURE__*/ function() {
    "use strict";
    function Action(element, index, descriptor, schema) {
        (0, $9j09T._)(this, Action);
        this.element = element;
        this.index = index;
        this.eventTarget = descriptor.eventTarget || element;
        this.eventName = descriptor.eventName || $8366b7adf73549a0$var$getDefaultEventNameForElement(element) || $8366b7adf73549a0$var$error("missing event name");
        this.eventOptions = descriptor.eventOptions || {};
        this.identifier = descriptor.identifier || $8366b7adf73549a0$var$error("missing identifier");
        this.methodName = descriptor.methodName || $8366b7adf73549a0$var$error("missing method name");
        this.keyFilter = descriptor.keyFilter || "";
        this.schema = schema;
    }
    (0, $eDeHT._)(Action, [
        {
            key: "toString",
            value: function toString() {
                var eventFilter = this.keyFilter ? ".".concat(this.keyFilter) : "";
                var eventTarget = this.eventTargetName ? "@".concat(this.eventTargetName) : "";
                return "".concat(this.eventName).concat(eventFilter).concat(eventTarget, "->").concat(this.identifier, "#").concat(this.methodName);
            }
        },
        {
            key: "shouldIgnoreKeyboardEvent",
            value: function shouldIgnoreKeyboardEvent(event) {
                if (!this.keyFilter) return false;
                var filters = this.keyFilter.split("+");
                if (this.keyFilterDissatisfied(event, filters)) return true;
                var standardFilter = filters.filter(function(key) {
                    return !$8366b7adf73549a0$var$allModifiers.includes(key);
                })[0];
                if (!standardFilter) return false;
                if (!$8366b7adf73549a0$var$hasProperty(this.keyMappings, standardFilter)) $8366b7adf73549a0$var$error("contains unknown key filter: ".concat(this.keyFilter));
                return this.keyMappings[standardFilter].toLowerCase() !== event.key.toLowerCase();
            }
        },
        {
            key: "shouldIgnoreMouseEvent",
            value: function shouldIgnoreMouseEvent(event) {
                if (!this.keyFilter) return false;
                var filters = [
                    this.keyFilter
                ];
                if (this.keyFilterDissatisfied(event, filters)) return true;
                return false;
            }
        },
        {
            key: "params",
            get: function get() {
                var params = {};
                var pattern = new RegExp("^data-".concat(this.identifier, "-(.+)-param$"), "i");
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Array.from(this.element.attributes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = _step.value, name = _step_value.name, value = _step_value.value;
                        var match = name.match(pattern);
                        var key = match && match[1];
                        if (key) params[$8366b7adf73549a0$var$camelize(key)] = $8366b7adf73549a0$var$typecast(value);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return params;
            }
        },
        {
            key: "eventTargetName",
            get: function get() {
                return $8366b7adf73549a0$var$stringifyEventTarget(this.eventTarget);
            }
        },
        {
            key: "keyMappings",
            get: function get() {
                return this.schema.keyMappings;
            }
        },
        {
            key: "keyFilterDissatisfied",
            value: function keyFilterDissatisfied(event, filters) {
                var _allModifiers_map = (0, $fyOZQ._)($8366b7adf73549a0$var$allModifiers.map(function(modifier) {
                    return filters.includes(modifier);
                }), 4), meta = _allModifiers_map[0], ctrl = _allModifiers_map[1], alt = _allModifiers_map[2], shift = _allModifiers_map[3];
                return event.metaKey !== meta || event.ctrlKey !== ctrl || event.altKey !== alt || event.shiftKey !== shift;
            }
        }
    ], [
        {
            key: "forToken",
            value: function forToken(token, schema) {
                return new this(token.element, token.index, $8366b7adf73549a0$var$parseActionDescriptorString(token.content), schema);
            }
        }
    ]);
    return Action;
}();
var $8366b7adf73549a0$var$defaultEventNames = {
    a: function() {
        return "click";
    },
    button: function() {
        return "click";
    },
    form: function() {
        return "submit";
    },
    details: function() {
        return "toggle";
    },
    input: function(e) {
        return e.getAttribute("type") == "submit" ? "click" : "input";
    },
    select: function() {
        return "change";
    },
    textarea: function() {
        return "input";
    }
};
function $8366b7adf73549a0$var$getDefaultEventNameForElement(element) {
    var tagName = element.tagName.toLowerCase();
    if (tagName in $8366b7adf73549a0$var$defaultEventNames) return $8366b7adf73549a0$var$defaultEventNames[tagName](element);
}
function $8366b7adf73549a0$var$error(message) {
    throw new Error(message);
}
function $8366b7adf73549a0$var$typecast(value) {
    try {
        return JSON.parse(value);
    } catch (o_O) {
        return value;
    }
}
var $8366b7adf73549a0$var$Binding = /*#__PURE__*/ function() {
    "use strict";
    function Binding(context, action) {
        (0, $9j09T._)(this, Binding);
        this.context = context;
        this.action = action;
    }
    (0, $eDeHT._)(Binding, [
        {
            key: "index",
            get: function get() {
                return this.action.index;
            }
        },
        {
            key: "eventTarget",
            get: function get() {
                return this.action.eventTarget;
            }
        },
        {
            key: "eventOptions",
            get: function get() {
                return this.action.eventOptions;
            }
        },
        {
            key: "identifier",
            get: function get() {
                return this.context.identifier;
            }
        },
        {
            key: "handleEvent",
            value: function handleEvent(event) {
                var actionEvent = this.prepareActionEvent(event);
                if (this.willBeInvokedByEvent(event) && this.applyEventModifiers(actionEvent)) this.invokeWithEvent(actionEvent);
            }
        },
        {
            key: "eventName",
            get: function get() {
                return this.action.eventName;
            }
        },
        {
            key: "method",
            get: function get() {
                var method = this.controller[this.methodName];
                if (typeof method == "function") return method;
                throw new Error('Action "'.concat(this.action, '" references undefined method "').concat(this.methodName, '"'));
            }
        },
        {
            key: "applyEventModifiers",
            value: function applyEventModifiers(event) {
                var element = this.action.element;
                var actionDescriptorFilters = this.context.application.actionDescriptorFilters;
                var controller = this.context.controller;
                var passes = true;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(this.eventOptions)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $fyOZQ._)(_step.value, 2), name = _step_value[0], value = _step_value[1];
                        if (name in actionDescriptorFilters) {
                            var filter = actionDescriptorFilters[name];
                            passes = passes && filter({
                                name: name,
                                value: value,
                                event: event,
                                element: element,
                                controller: controller
                            });
                        } else continue;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return passes;
            }
        },
        {
            key: "prepareActionEvent",
            value: function prepareActionEvent(event) {
                return Object.assign(event, {
                    params: this.action.params
                });
            }
        },
        {
            key: "invokeWithEvent",
            value: function invokeWithEvent(event) {
                var target = event.target, currentTarget = event.currentTarget;
                try {
                    this.method.call(this.controller, event);
                    this.context.logDebugActivity(this.methodName, {
                        event: event,
                        target: target,
                        currentTarget: currentTarget,
                        action: this.methodName
                    });
                } catch (error) {
                    var _this = this, identifier = _this.identifier, controller = _this.controller, element = _this.element, index = _this.index;
                    var detail = {
                        identifier: identifier,
                        controller: controller,
                        element: element,
                        index: index,
                        event: event
                    };
                    this.context.handleError(error, 'invoking action "'.concat(this.action, '"'), detail);
                }
            }
        },
        {
            key: "willBeInvokedByEvent",
            value: function willBeInvokedByEvent(event) {
                var eventTarget = event.target;
                if (event instanceof KeyboardEvent && this.action.shouldIgnoreKeyboardEvent(event)) return false;
                if (event instanceof MouseEvent && this.action.shouldIgnoreMouseEvent(event)) return false;
                if (this.element === eventTarget) return true;
                else if (eventTarget instanceof Element && this.element.contains(eventTarget)) return this.scope.containsElement(eventTarget);
                else return this.scope.containsElement(this.action.element);
            }
        },
        {
            key: "controller",
            get: function get() {
                return this.context.controller;
            }
        },
        {
            key: "methodName",
            get: function get() {
                return this.action.methodName;
            }
        },
        {
            key: "element",
            get: function get() {
                return this.scope.element;
            }
        },
        {
            key: "scope",
            get: function get() {
                return this.context.scope;
            }
        }
    ]);
    return Binding;
}();
var $8366b7adf73549a0$export$12e07a2a9f87578a = /*#__PURE__*/ function() {
    "use strict";
    function ElementObserver(element, delegate) {
        var _this = this;
        (0, $9j09T._)(this, ElementObserver);
        this.mutationObserverInit = {
            attributes: true,
            childList: true,
            subtree: true
        };
        this.element = element;
        this.started = false;
        this.delegate = delegate;
        this.elements = new Set();
        this.mutationObserver = new MutationObserver(function(mutations) {
            return _this.processMutations(mutations);
        });
    }
    (0, $eDeHT._)(ElementObserver, [
        {
            key: "start",
            value: function start() {
                if (!this.started) {
                    this.started = true;
                    this.mutationObserver.observe(this.element, this.mutationObserverInit);
                    this.refresh();
                }
            }
        },
        {
            key: "pause",
            value: function pause(callback) {
                if (this.started) {
                    this.mutationObserver.disconnect();
                    this.started = false;
                }
                callback();
                if (!this.started) {
                    this.mutationObserver.observe(this.element, this.mutationObserverInit);
                    this.started = true;
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.started) {
                    this.mutationObserver.takeRecords();
                    this.mutationObserver.disconnect();
                    this.started = false;
                }
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                if (this.started) {
                    var matches = new Set(this.matchElementsInTree());
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Array.from(this.elements)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var element = _step.value;
                            if (!matches.has(element)) this.removeElement(element);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = Array.from(matches)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var element1 = _step1.value;
                            this.addElement(element1);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
            }
        },
        {
            key: "processMutations",
            value: function processMutations(mutations) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (this.started) try {
                    for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var mutation = _step.value;
                        this.processMutation(mutation);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "processMutation",
            value: function processMutation(mutation) {
                if (mutation.type == "attributes") this.processAttributeChange(mutation.target, mutation.attributeName);
                else if (mutation.type == "childList") {
                    this.processRemovedNodes(mutation.removedNodes);
                    this.processAddedNodes(mutation.addedNodes);
                }
            }
        },
        {
            key: "processAttributeChange",
            value: function processAttributeChange(element, attributeName) {
                if (this.elements.has(element)) {
                    if (this.delegate.elementAttributeChanged && this.matchElement(element)) this.delegate.elementAttributeChanged(element, attributeName);
                    else this.removeElement(element);
                } else if (this.matchElement(element)) this.addElement(element);
            }
        },
        {
            key: "processRemovedNodes",
            value: function processRemovedNodes(nodes) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Array.from(nodes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        var element = this.elementFromNode(node);
                        if (element) this.processTree(element, this.removeElement);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "processAddedNodes",
            value: function processAddedNodes(nodes) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Array.from(nodes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        var element = this.elementFromNode(node);
                        if (element && this.elementIsActive(element)) this.processTree(element, this.addElement);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "matchElement",
            value: function matchElement(element) {
                return this.delegate.matchElement(element);
            }
        },
        {
            key: "matchElementsInTree",
            value: function matchElementsInTree() {
                var tree = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.element;
                return this.delegate.matchElementsInTree(tree);
            }
        },
        {
            key: "processTree",
            value: function processTree(tree, processor) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.matchElementsInTree(tree)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        processor.call(this, element);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "elementFromNode",
            value: function elementFromNode(node) {
                if (node.nodeType == Node.ELEMENT_NODE) return node;
            }
        },
        {
            key: "elementIsActive",
            value: function elementIsActive(element) {
                if (element.isConnected != this.element.isConnected) return false;
                else return this.element.contains(element);
            }
        },
        {
            key: "addElement",
            value: function addElement(element) {
                if (!this.elements.has(element)) {
                    if (this.elementIsActive(element)) {
                        this.elements.add(element);
                        if (this.delegate.elementMatched) this.delegate.elementMatched(element);
                    }
                }
            }
        },
        {
            key: "removeElement",
            value: function removeElement(element) {
                if (this.elements.has(element)) {
                    this.elements.delete(element);
                    if (this.delegate.elementUnmatched) this.delegate.elementUnmatched(element);
                }
            }
        }
    ]);
    return ElementObserver;
}();
var $8366b7adf73549a0$export$fe68319d413d05cb = /*#__PURE__*/ function() {
    "use strict";
    function AttributeObserver(element, attributeName, delegate) {
        (0, $9j09T._)(this, AttributeObserver);
        this.attributeName = attributeName;
        this.delegate = delegate;
        this.elementObserver = new $8366b7adf73549a0$export$12e07a2a9f87578a(element, this);
    }
    (0, $eDeHT._)(AttributeObserver, [
        {
            key: "element",
            get: function get() {
                return this.elementObserver.element;
            }
        },
        {
            key: "selector",
            get: function get() {
                return "[".concat(this.attributeName, "]");
            }
        },
        {
            key: "start",
            value: function start() {
                this.elementObserver.start();
            }
        },
        {
            key: "pause",
            value: function pause(callback) {
                this.elementObserver.pause(callback);
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.elementObserver.stop();
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                this.elementObserver.refresh();
            }
        },
        {
            key: "started",
            get: function get() {
                return this.elementObserver.started;
            }
        },
        {
            key: "matchElement",
            value: function matchElement(element) {
                return element.hasAttribute(this.attributeName);
            }
        },
        {
            key: "matchElementsInTree",
            value: function matchElementsInTree(tree) {
                var match = this.matchElement(tree) ? [
                    tree
                ] : [];
                var matches = Array.from(tree.querySelectorAll(this.selector));
                return match.concat(matches);
            }
        },
        {
            key: "elementMatched",
            value: function elementMatched(element) {
                if (this.delegate.elementMatchedAttribute) this.delegate.elementMatchedAttribute(element, this.attributeName);
            }
        },
        {
            key: "elementUnmatched",
            value: function elementUnmatched(element) {
                if (this.delegate.elementUnmatchedAttribute) this.delegate.elementUnmatchedAttribute(element, this.attributeName);
            }
        },
        {
            key: "elementAttributeChanged",
            value: function elementAttributeChanged(element, attributeName) {
                if (this.delegate.elementAttributeValueChanged && this.attributeName == attributeName) this.delegate.elementAttributeValueChanged(element, attributeName);
            }
        }
    ]);
    return AttributeObserver;
}();
function $8366b7adf73549a0$export$e16d8520af44a096(map, key, value) {
    $8366b7adf73549a0$export$e7aa7bc5c1b3cfb3(map, key).add(value);
}
function $8366b7adf73549a0$export$1d2f21e549771e67(map, key, value) {
    $8366b7adf73549a0$export$e7aa7bc5c1b3cfb3(map, key).delete(value);
    $8366b7adf73549a0$export$d6cf75919f12ca5a(map, key);
}
function $8366b7adf73549a0$export$e7aa7bc5c1b3cfb3(map, key) {
    var values = map.get(key);
    if (!values) {
        values = new Set();
        map.set(key, values);
    }
    return values;
}
function $8366b7adf73549a0$export$d6cf75919f12ca5a(map, key) {
    var values = map.get(key);
    if (values != null && values.size == 0) map.delete(key);
}
var $8366b7adf73549a0$export$8bd4ad37b76db6ba = /*#__PURE__*/ function() {
    "use strict";
    function Multimap() {
        (0, $9j09T._)(this, Multimap);
        this.valuesByKey = new Map();
    }
    (0, $eDeHT._)(Multimap, [
        {
            key: "keys",
            get: function get() {
                return Array.from(this.valuesByKey.keys());
            }
        },
        {
            key: "values",
            get: function get() {
                var sets = Array.from(this.valuesByKey.values());
                return sets.reduce(function(values, set) {
                    return values.concat(Array.from(set));
                }, []);
            }
        },
        {
            key: "size",
            get: function get() {
                var sets = Array.from(this.valuesByKey.values());
                return sets.reduce(function(size, set) {
                    return size + set.size;
                }, 0);
            }
        },
        {
            key: "add",
            value: function add1(key, value) {
                $8366b7adf73549a0$export$e16d8520af44a096(this.valuesByKey, key, value);
            }
        },
        {
            key: "delete",
            value: function _delete(key, value) {
                $8366b7adf73549a0$export$1d2f21e549771e67(this.valuesByKey, key, value);
            }
        },
        {
            key: "has",
            value: function has(key, value) {
                var values = this.valuesByKey.get(key);
                return values != null && values.has(value);
            }
        },
        {
            key: "hasKey",
            value: function hasKey(key) {
                return this.valuesByKey.has(key);
            }
        },
        {
            key: "hasValue",
            value: function hasValue(value) {
                var sets = Array.from(this.valuesByKey.values());
                return sets.some(function(set) {
                    return set.has(value);
                });
            }
        },
        {
            key: "getValuesForKey",
            value: function getValuesForKey(key) {
                var values = this.valuesByKey.get(key);
                return values ? Array.from(values) : [];
            }
        },
        {
            key: "getKeysForValue",
            value: function getKeysForValue(value) {
                return Array.from(this.valuesByKey).filter(function(param) {
                    var _param = (0, $fyOZQ._)(param, 2), _key = _param[0], values = _param[1];
                    return values.has(value);
                }).map(function(param) {
                    var _param = (0, $fyOZQ._)(param, 2), key = _param[0], _values = _param[1];
                    return key;
                });
            }
        }
    ]);
    return Multimap;
}();
var $8366b7adf73549a0$export$a7c3d2c2552a674d = /*#__PURE__*/ function(Multimap) {
    "use strict";
    (0, $i0LXg._)(IndexedMultimap, Multimap);
    var _super = (0, $a1vXf._)(IndexedMultimap);
    function IndexedMultimap() {
        (0, $9j09T._)(this, IndexedMultimap);
        var _this;
        _this = _super.call(this);
        _this.keysByValue = new Map();
        return _this;
    }
    (0, $eDeHT._)(IndexedMultimap, [
        {
            key: "values",
            get: function get() {
                return Array.from(this.keysByValue.keys());
            }
        },
        {
            key: "add",
            value: function add1(key, value) {
                (0, $15W2b._)((0, $711He._)(IndexedMultimap.prototype), "add", this).call(this, key, value);
                $8366b7adf73549a0$export$e16d8520af44a096(this.keysByValue, value, key);
            }
        },
        {
            key: "delete",
            value: function _delete(key, value) {
                (0, $15W2b._)((0, $711He._)(IndexedMultimap.prototype), "delete", this).call(this, key, value);
                $8366b7adf73549a0$export$1d2f21e549771e67(this.keysByValue, value, key);
            }
        },
        {
            key: "hasValue",
            value: function hasValue(value) {
                return this.keysByValue.has(value);
            }
        },
        {
            key: "getKeysForValue",
            value: function getKeysForValue(value) {
                var set = this.keysByValue.get(value);
                return set ? Array.from(set) : [];
            }
        }
    ]);
    return IndexedMultimap;
}($8366b7adf73549a0$export$8bd4ad37b76db6ba);
var $8366b7adf73549a0$export$116e0b48509995b = /*#__PURE__*/ function() {
    "use strict";
    function SelectorObserver(element, selector, delegate, details) {
        (0, $9j09T._)(this, SelectorObserver);
        this._selector = selector;
        this.details = details;
        this.elementObserver = new $8366b7adf73549a0$export$12e07a2a9f87578a(element, this);
        this.delegate = delegate;
        this.matchesByElement = new $8366b7adf73549a0$export$8bd4ad37b76db6ba();
    }
    (0, $eDeHT._)(SelectorObserver, [
        {
            key: "started",
            get: function get() {
                return this.elementObserver.started;
            }
        },
        {
            key: "selector",
            get: function get() {
                return this._selector;
            },
            set: function set(selector) {
                this._selector = selector;
                this.refresh();
            }
        },
        {
            key: "start",
            value: function start() {
                this.elementObserver.start();
            }
        },
        {
            key: "pause",
            value: function pause(callback) {
                this.elementObserver.pause(callback);
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.elementObserver.stop();
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                this.elementObserver.refresh();
            }
        },
        {
            key: "element",
            get: function get() {
                return this.elementObserver.element;
            }
        },
        {
            key: "matchElement",
            value: function matchElement(element) {
                var selector = this.selector;
                if (selector) {
                    var matches = element.matches(selector);
                    if (this.delegate.selectorMatchElement) return matches && this.delegate.selectorMatchElement(element, this.details);
                    return matches;
                } else return false;
            }
        },
        {
            key: "matchElementsInTree",
            value: function matchElementsInTree(tree) {
                var _this = this;
                var selector = this.selector;
                if (selector) {
                    var match = this.matchElement(tree) ? [
                        tree
                    ] : [];
                    var matches = Array.from(tree.querySelectorAll(selector)).filter(function(match) {
                        return _this.matchElement(match);
                    });
                    return match.concat(matches);
                } else return [];
            }
        },
        {
            key: "elementMatched",
            value: function elementMatched(element) {
                var selector = this.selector;
                if (selector) this.selectorMatched(element, selector);
            }
        },
        {
            key: "elementUnmatched",
            value: function elementUnmatched(element) {
                var selectors = this.matchesByElement.getKeysForValue(element);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = selectors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var selector = _step.value;
                        this.selectorUnmatched(element, selector);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "elementAttributeChanged",
            value: function elementAttributeChanged(element, _attributeName) {
                var selector = this.selector;
                if (selector) {
                    var matches = this.matchElement(element);
                    var matchedBefore = this.matchesByElement.has(selector, element);
                    if (matches && !matchedBefore) this.selectorMatched(element, selector);
                    else if (!matches && matchedBefore) this.selectorUnmatched(element, selector);
                }
            }
        },
        {
            key: "selectorMatched",
            value: function selectorMatched(element, selector) {
                this.delegate.selectorMatched(element, selector, this.details);
                this.matchesByElement.add(selector, element);
            }
        },
        {
            key: "selectorUnmatched",
            value: function selectorUnmatched(element, selector) {
                this.delegate.selectorUnmatched(element, selector, this.details);
                this.matchesByElement.delete(selector, element);
            }
        }
    ]);
    return SelectorObserver;
}();
var $8366b7adf73549a0$export$da226bebbf7f6caa = /*#__PURE__*/ function() {
    "use strict";
    function StringMapObserver(element, delegate) {
        var _this = this;
        (0, $9j09T._)(this, StringMapObserver);
        this.element = element;
        this.delegate = delegate;
        this.started = false;
        this.stringMap = new Map();
        this.mutationObserver = new MutationObserver(function(mutations) {
            return _this.processMutations(mutations);
        });
    }
    (0, $eDeHT._)(StringMapObserver, [
        {
            key: "start",
            value: function start() {
                if (!this.started) {
                    this.started = true;
                    this.mutationObserver.observe(this.element, {
                        attributes: true,
                        attributeOldValue: true
                    });
                    this.refresh();
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.started) {
                    this.mutationObserver.takeRecords();
                    this.mutationObserver.disconnect();
                    this.started = false;
                }
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (this.started) try {
                    for(var _iterator = this.knownAttributeNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var attributeName = _step.value;
                        this.refreshAttribute(attributeName, null);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "processMutations",
            value: function processMutations(mutations) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (this.started) try {
                    for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var mutation = _step.value;
                        this.processMutation(mutation);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "processMutation",
            value: function processMutation(mutation) {
                var attributeName = mutation.attributeName;
                if (attributeName) this.refreshAttribute(attributeName, mutation.oldValue);
            }
        },
        {
            key: "refreshAttribute",
            value: function refreshAttribute(attributeName, oldValue) {
                var key = this.delegate.getStringMapKeyForAttribute(attributeName);
                if (key != null) {
                    if (!this.stringMap.has(attributeName)) this.stringMapKeyAdded(key, attributeName);
                    var value = this.element.getAttribute(attributeName);
                    if (this.stringMap.get(attributeName) != value) this.stringMapValueChanged(value, key, oldValue);
                    if (value == null) {
                        var _$oldValue = this.stringMap.get(attributeName);
                        this.stringMap.delete(attributeName);
                        if (_$oldValue) this.stringMapKeyRemoved(key, attributeName, _$oldValue);
                    } else this.stringMap.set(attributeName, value);
                }
            }
        },
        {
            key: "stringMapKeyAdded",
            value: function stringMapKeyAdded(key, attributeName) {
                if (this.delegate.stringMapKeyAdded) this.delegate.stringMapKeyAdded(key, attributeName);
            }
        },
        {
            key: "stringMapValueChanged",
            value: function stringMapValueChanged(value, key, oldValue) {
                if (this.delegate.stringMapValueChanged) this.delegate.stringMapValueChanged(value, key, oldValue);
            }
        },
        {
            key: "stringMapKeyRemoved",
            value: function stringMapKeyRemoved(key, attributeName, oldValue) {
                if (this.delegate.stringMapKeyRemoved) this.delegate.stringMapKeyRemoved(key, attributeName, oldValue);
            }
        },
        {
            key: "knownAttributeNames",
            get: function get() {
                return Array.from(new Set(this.currentAttributeNames.concat(this.recordedAttributeNames)));
            }
        },
        {
            key: "currentAttributeNames",
            get: function get() {
                return Array.from(this.element.attributes).map(function(attribute) {
                    return attribute.name;
                });
            }
        },
        {
            key: "recordedAttributeNames",
            get: function get() {
                return Array.from(this.stringMap.keys());
            }
        }
    ]);
    return StringMapObserver;
}();
var $8366b7adf73549a0$export$3aa21c2f03ef6b3b = /*#__PURE__*/ function() {
    "use strict";
    function TokenListObserver(element, attributeName, delegate) {
        (0, $9j09T._)(this, TokenListObserver);
        this.attributeObserver = new $8366b7adf73549a0$export$fe68319d413d05cb(element, attributeName, this);
        this.delegate = delegate;
        this.tokensByElement = new $8366b7adf73549a0$export$8bd4ad37b76db6ba();
    }
    (0, $eDeHT._)(TokenListObserver, [
        {
            key: "started",
            get: function get() {
                return this.attributeObserver.started;
            }
        },
        {
            key: "start",
            value: function start() {
                this.attributeObserver.start();
            }
        },
        {
            key: "pause",
            value: function pause(callback) {
                this.attributeObserver.pause(callback);
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.attributeObserver.stop();
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                this.attributeObserver.refresh();
            }
        },
        {
            key: "element",
            get: function get() {
                return this.attributeObserver.element;
            }
        },
        {
            key: "attributeName",
            get: function get() {
                return this.attributeObserver.attributeName;
            }
        },
        {
            key: "elementMatchedAttribute",
            value: function elementMatchedAttribute(element) {
                this.tokensMatched(this.readTokensForElement(element));
            }
        },
        {
            key: "elementAttributeValueChanged",
            value: function elementAttributeValueChanged(element) {
                var _this_refreshTokensForElement = (0, $fyOZQ._)(this.refreshTokensForElement(element), 2), unmatchedTokens = _this_refreshTokensForElement[0], matchedTokens = _this_refreshTokensForElement[1];
                this.tokensUnmatched(unmatchedTokens);
                this.tokensMatched(matchedTokens);
            }
        },
        {
            key: "elementUnmatchedAttribute",
            value: function elementUnmatchedAttribute(element) {
                this.tokensUnmatched(this.tokensByElement.getValuesForKey(element));
            }
        },
        {
            key: "tokensMatched",
            value: function tokensMatched(tokens) {
                var _this = this;
                tokens.forEach(function(token) {
                    return _this.tokenMatched(token);
                });
            }
        },
        {
            key: "tokensUnmatched",
            value: function tokensUnmatched(tokens) {
                var _this = this;
                tokens.forEach(function(token) {
                    return _this.tokenUnmatched(token);
                });
            }
        },
        {
            key: "tokenMatched",
            value: function tokenMatched(token) {
                this.delegate.tokenMatched(token);
                this.tokensByElement.add(token.element, token);
            }
        },
        {
            key: "tokenUnmatched",
            value: function tokenUnmatched(token) {
                this.delegate.tokenUnmatched(token);
                this.tokensByElement.delete(token.element, token);
            }
        },
        {
            key: "refreshTokensForElement",
            value: function refreshTokensForElement(element) {
                var previousTokens = this.tokensByElement.getValuesForKey(element);
                var currentTokens = this.readTokensForElement(element);
                var firstDifferingIndex = $8366b7adf73549a0$var$zip(previousTokens, currentTokens).findIndex(function(param) {
                    var _param = (0, $fyOZQ._)(param, 2), previousToken = _param[0], currentToken = _param[1];
                    return !$8366b7adf73549a0$var$tokensAreEqual(previousToken, currentToken);
                });
                if (firstDifferingIndex == -1) return [
                    [],
                    []
                ];
                else return [
                    previousTokens.slice(firstDifferingIndex),
                    currentTokens.slice(firstDifferingIndex)
                ];
            }
        },
        {
            key: "readTokensForElement",
            value: function readTokensForElement(element) {
                var attributeName = this.attributeName;
                var tokenString = element.getAttribute(attributeName) || "";
                return $8366b7adf73549a0$var$parseTokenString(tokenString, element, attributeName);
            }
        }
    ]);
    return TokenListObserver;
}();
function $8366b7adf73549a0$var$parseTokenString(tokenString, element, attributeName) {
    return tokenString.trim().split(/\s+/).filter(function(content) {
        return content.length;
    }).map(function(content, index) {
        return {
            element: element,
            attributeName: attributeName,
            content: content,
            index: index
        };
    });
}
function $8366b7adf73549a0$var$zip(left, right) {
    var length = Math.max(left.length, right.length);
    return Array.from({
        length: length
    }, function(_, index) {
        return [
            left[index],
            right[index]
        ];
    });
}
function $8366b7adf73549a0$var$tokensAreEqual(left, right) {
    return left && right && left.index == right.index && left.content == right.content;
}
var $8366b7adf73549a0$export$d27fa4c7330a452e = /*#__PURE__*/ function() {
    "use strict";
    function ValueListObserver(element, attributeName, delegate) {
        (0, $9j09T._)(this, ValueListObserver);
        this.tokenListObserver = new $8366b7adf73549a0$export$3aa21c2f03ef6b3b(element, attributeName, this);
        this.delegate = delegate;
        this.parseResultsByToken = new WeakMap();
        this.valuesByTokenByElement = new WeakMap();
    }
    (0, $eDeHT._)(ValueListObserver, [
        {
            key: "started",
            get: function get() {
                return this.tokenListObserver.started;
            }
        },
        {
            key: "start",
            value: function start() {
                this.tokenListObserver.start();
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.tokenListObserver.stop();
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                this.tokenListObserver.refresh();
            }
        },
        {
            key: "element",
            get: function get() {
                return this.tokenListObserver.element;
            }
        },
        {
            key: "attributeName",
            get: function get() {
                return this.tokenListObserver.attributeName;
            }
        },
        {
            key: "tokenMatched",
            value: function tokenMatched(token) {
                var element = token.element;
                var value = this.fetchParseResultForToken(token).value;
                if (value) {
                    this.fetchValuesByTokenForElement(element).set(token, value);
                    this.delegate.elementMatchedValue(element, value);
                }
            }
        },
        {
            key: "tokenUnmatched",
            value: function tokenUnmatched(token) {
                var element = token.element;
                var value = this.fetchParseResultForToken(token).value;
                if (value) {
                    this.fetchValuesByTokenForElement(element).delete(token);
                    this.delegate.elementUnmatchedValue(element, value);
                }
            }
        },
        {
            key: "fetchParseResultForToken",
            value: function fetchParseResultForToken(token) {
                var parseResult = this.parseResultsByToken.get(token);
                if (!parseResult) {
                    parseResult = this.parseToken(token);
                    this.parseResultsByToken.set(token, parseResult);
                }
                return parseResult;
            }
        },
        {
            key: "fetchValuesByTokenForElement",
            value: function fetchValuesByTokenForElement(element) {
                var valuesByToken = this.valuesByTokenByElement.get(element);
                if (!valuesByToken) {
                    valuesByToken = new Map();
                    this.valuesByTokenByElement.set(element, valuesByToken);
                }
                return valuesByToken;
            }
        },
        {
            key: "parseToken",
            value: function parseToken(token) {
                try {
                    var value = this.delegate.parseValueForToken(token);
                    return {
                        value: value
                    };
                } catch (error) {
                    return {
                        error: error
                    };
                }
            }
        }
    ]);
    return ValueListObserver;
}();
var $8366b7adf73549a0$var$BindingObserver = /*#__PURE__*/ function() {
    "use strict";
    function BindingObserver(context, delegate) {
        (0, $9j09T._)(this, BindingObserver);
        this.context = context;
        this.delegate = delegate;
        this.bindingsByAction = new Map();
    }
    (0, $eDeHT._)(BindingObserver, [
        {
            key: "start",
            value: function start() {
                if (!this.valueListObserver) {
                    this.valueListObserver = new $8366b7adf73549a0$export$d27fa4c7330a452e(this.element, this.actionAttribute, this);
                    this.valueListObserver.start();
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.valueListObserver) {
                    this.valueListObserver.stop();
                    delete this.valueListObserver;
                    this.disconnectAllActions();
                }
            }
        },
        {
            key: "element",
            get: function get() {
                return this.context.element;
            }
        },
        {
            key: "identifier",
            get: function get() {
                return this.context.identifier;
            }
        },
        {
            key: "actionAttribute",
            get: function get() {
                return this.schema.actionAttribute;
            }
        },
        {
            key: "schema",
            get: function get() {
                return this.context.schema;
            }
        },
        {
            key: "bindings",
            get: function get() {
                return Array.from(this.bindingsByAction.values());
            }
        },
        {
            key: "connectAction",
            value: function connectAction(action) {
                var binding = new $8366b7adf73549a0$var$Binding(this.context, action);
                this.bindingsByAction.set(action, binding);
                this.delegate.bindingConnected(binding);
            }
        },
        {
            key: "disconnectAction",
            value: function disconnectAction(action) {
                var binding = this.bindingsByAction.get(action);
                if (binding) {
                    this.bindingsByAction.delete(action);
                    this.delegate.bindingDisconnected(binding);
                }
            }
        },
        {
            key: "disconnectAllActions",
            value: function disconnectAllActions() {
                var _this = this;
                this.bindings.forEach(function(binding) {
                    return _this.delegate.bindingDisconnected(binding, true);
                });
                this.bindingsByAction.clear();
            }
        },
        {
            key: "parseValueForToken",
            value: function parseValueForToken(token) {
                var action = $8366b7adf73549a0$var$Action.forToken(token, this.schema);
                if (action.identifier == this.identifier) return action;
            }
        },
        {
            key: "elementMatchedValue",
            value: function elementMatchedValue(element, action) {
                this.connectAction(action);
            }
        },
        {
            key: "elementUnmatchedValue",
            value: function elementUnmatchedValue(element, action) {
                this.disconnectAction(action);
            }
        }
    ]);
    return BindingObserver;
}();
var $8366b7adf73549a0$var$ValueObserver = /*#__PURE__*/ function() {
    "use strict";
    function ValueObserver(context, receiver) {
        (0, $9j09T._)(this, ValueObserver);
        this.context = context;
        this.receiver = receiver;
        this.stringMapObserver = new $8366b7adf73549a0$export$da226bebbf7f6caa(this.element, this);
        this.valueDescriptorMap = this.controller.valueDescriptorMap;
    }
    (0, $eDeHT._)(ValueObserver, [
        {
            key: "start",
            value: function start() {
                this.stringMapObserver.start();
                this.invokeChangedCallbacksForDefaultValues();
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.stringMapObserver.stop();
            }
        },
        {
            key: "element",
            get: function get() {
                return this.context.element;
            }
        },
        {
            key: "controller",
            get: function get() {
                return this.context.controller;
            }
        },
        {
            key: "getStringMapKeyForAttribute",
            value: function getStringMapKeyForAttribute(attributeName) {
                if (attributeName in this.valueDescriptorMap) return this.valueDescriptorMap[attributeName].name;
            }
        },
        {
            key: "stringMapKeyAdded",
            value: function stringMapKeyAdded(key, attributeName) {
                var descriptor = this.valueDescriptorMap[attributeName];
                if (!this.hasValue(key)) this.invokeChangedCallback(key, descriptor.writer(this.receiver[key]), descriptor.writer(descriptor.defaultValue));
            }
        },
        {
            key: "stringMapValueChanged",
            value: function stringMapValueChanged(value, name, oldValue) {
                var descriptor = this.valueDescriptorNameMap[name];
                if (value === null) return;
                if (oldValue === null) oldValue = descriptor.writer(descriptor.defaultValue);
                this.invokeChangedCallback(name, value, oldValue);
            }
        },
        {
            key: "stringMapKeyRemoved",
            value: function stringMapKeyRemoved(key, attributeName, oldValue) {
                var descriptor = this.valueDescriptorNameMap[key];
                if (this.hasValue(key)) this.invokeChangedCallback(key, descriptor.writer(this.receiver[key]), oldValue);
                else this.invokeChangedCallback(key, descriptor.writer(descriptor.defaultValue), oldValue);
            }
        },
        {
            key: "invokeChangedCallbacksForDefaultValues",
            value: function invokeChangedCallbacksForDefaultValues() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.valueDescriptors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = _step.value, key = _step_value.key, name = _step_value.name, defaultValue = _step_value.defaultValue, writer = _step_value.writer;
                        if (defaultValue != undefined && !this.controller.data.has(key)) this.invokeChangedCallback(name, writer(defaultValue), undefined);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "invokeChangedCallback",
            value: function invokeChangedCallback(name, rawValue, rawOldValue) {
                var changedMethodName = "".concat(name, "Changed");
                var changedMethod = this.receiver[changedMethodName];
                if (typeof changedMethod == "function") {
                    var descriptor = this.valueDescriptorNameMap[name];
                    try {
                        var value = descriptor.reader(rawValue);
                        var oldValue = rawOldValue;
                        if (rawOldValue) oldValue = descriptor.reader(rawOldValue);
                        changedMethod.call(this.receiver, value, oldValue);
                    } catch (error) {
                        if (error instanceof TypeError) error.message = 'Stimulus Value "'.concat(this.context.identifier, ".").concat(descriptor.name, '" - ').concat(error.message);
                        throw error;
                    }
                }
            }
        },
        {
            key: "valueDescriptors",
            get: function get() {
                var valueDescriptorMap = this.valueDescriptorMap;
                return Object.keys(valueDescriptorMap).map(function(key) {
                    return valueDescriptorMap[key];
                });
            }
        },
        {
            key: "valueDescriptorNameMap",
            get: function get() {
                var _this = this;
                var descriptors = {};
                Object.keys(this.valueDescriptorMap).forEach(function(key) {
                    var descriptor = _this.valueDescriptorMap[key];
                    descriptors[descriptor.name] = descriptor;
                });
                return descriptors;
            }
        },
        {
            key: "hasValue",
            value: function hasValue(attributeName) {
                var descriptor = this.valueDescriptorNameMap[attributeName];
                var hasMethodName = "has".concat($8366b7adf73549a0$var$capitalize(descriptor.name));
                return this.receiver[hasMethodName];
            }
        }
    ]);
    return ValueObserver;
}();
var $8366b7adf73549a0$var$TargetObserver = /*#__PURE__*/ function() {
    "use strict";
    function TargetObserver(context, delegate) {
        (0, $9j09T._)(this, TargetObserver);
        this.context = context;
        this.delegate = delegate;
        this.targetsByName = new $8366b7adf73549a0$export$8bd4ad37b76db6ba();
    }
    (0, $eDeHT._)(TargetObserver, [
        {
            key: "start",
            value: function start() {
                if (!this.tokenListObserver) {
                    this.tokenListObserver = new $8366b7adf73549a0$export$3aa21c2f03ef6b3b(this.element, this.attributeName, this);
                    this.tokenListObserver.start();
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.tokenListObserver) {
                    this.disconnectAllTargets();
                    this.tokenListObserver.stop();
                    delete this.tokenListObserver;
                }
            }
        },
        {
            key: "tokenMatched",
            value: function tokenMatched(param) {
                var element = param.element, name = param.content;
                if (this.scope.containsElement(element)) this.connectTarget(element, name);
            }
        },
        {
            key: "tokenUnmatched",
            value: function tokenUnmatched(param) {
                var element = param.element, name = param.content;
                this.disconnectTarget(element, name);
            }
        },
        {
            key: "connectTarget",
            value: function connectTarget(element, name) {
                var _this = this;
                var _a;
                if (!this.targetsByName.has(name, element)) {
                    this.targetsByName.add(name, element);
                    (_a = this.tokenListObserver) === null || _a === void 0 || _a.pause(function() {
                        return _this.delegate.targetConnected(element, name);
                    });
                }
            }
        },
        {
            key: "disconnectTarget",
            value: function disconnectTarget(element, name) {
                var _this = this;
                var _a;
                if (this.targetsByName.has(name, element)) {
                    this.targetsByName.delete(name, element);
                    (_a = this.tokenListObserver) === null || _a === void 0 || _a.pause(function() {
                        return _this.delegate.targetDisconnected(element, name);
                    });
                }
            }
        },
        {
            key: "disconnectAllTargets",
            value: function disconnectAllTargets() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator = this.targetsByName.keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                        var name = _step.value;
                        try {
                            for(var _iterator1 = this.targetsByName.getValuesForKey(name)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                var element = _step1.value;
                                this.disconnectTarget(element, name);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        },
        {
            key: "attributeName",
            get: function get() {
                return "data-".concat(this.context.identifier, "-target");
            }
        },
        {
            key: "element",
            get: function get() {
                return this.context.element;
            }
        },
        {
            key: "scope",
            get: function get() {
                return this.context.scope;
            }
        }
    ]);
    return TargetObserver;
}();
function $8366b7adf73549a0$var$readInheritableStaticArrayValues(constructor, propertyName) {
    var ancestors = $8366b7adf73549a0$var$getAncestorsForConstructor(constructor);
    return Array.from(ancestors.reduce(function(values, constructor) {
        $8366b7adf73549a0$var$getOwnStaticArrayValues(constructor, propertyName).forEach(function(name) {
            return values.add(name);
        });
        return values;
    }, new Set()));
}
function $8366b7adf73549a0$var$readInheritableStaticObjectPairs(constructor, propertyName) {
    var ancestors = $8366b7adf73549a0$var$getAncestorsForConstructor(constructor);
    return ancestors.reduce(function(pairs, constructor) {
        var _pairs;
        (_pairs = pairs).push.apply(_pairs, (0, $enL5v._)($8366b7adf73549a0$var$getOwnStaticObjectPairs(constructor, propertyName)));
        return pairs;
    }, []);
}
function $8366b7adf73549a0$var$getAncestorsForConstructor(constructor) {
    var ancestors = [];
    while(constructor){
        ancestors.push(constructor);
        constructor = Object.getPrototypeOf(constructor);
    }
    return ancestors.reverse();
}
function $8366b7adf73549a0$var$getOwnStaticArrayValues(constructor, propertyName) {
    var definition = constructor[propertyName];
    return Array.isArray(definition) ? definition : [];
}
function $8366b7adf73549a0$var$getOwnStaticObjectPairs(constructor, propertyName) {
    var definition = constructor[propertyName];
    return definition ? Object.keys(definition).map(function(key) {
        return [
            key,
            definition[key]
        ];
    }) : [];
}
var $8366b7adf73549a0$var$OutletObserver = /*#__PURE__*/ function() {
    "use strict";
    function OutletObserver(context, delegate) {
        (0, $9j09T._)(this, OutletObserver);
        this.started = false;
        this.context = context;
        this.delegate = delegate;
        this.outletsByName = new $8366b7adf73549a0$export$8bd4ad37b76db6ba();
        this.outletElementsByName = new $8366b7adf73549a0$export$8bd4ad37b76db6ba();
        this.selectorObserverMap = new Map();
        this.attributeObserverMap = new Map();
    }
    (0, $eDeHT._)(OutletObserver, [
        {
            key: "start",
            value: function start() {
                var _this = this;
                if (!this.started) {
                    this.outletDefinitions.forEach(function(outletName) {
                        _this.setupSelectorObserverForOutlet(outletName);
                        _this.setupAttributeObserverForOutlet(outletName);
                    });
                    this.started = true;
                    this.dependentContexts.forEach(function(context) {
                        return context.refresh();
                    });
                }
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                this.selectorObserverMap.forEach(function(observer) {
                    return observer.refresh();
                });
                this.attributeObserverMap.forEach(function(observer) {
                    return observer.refresh();
                });
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.started) {
                    this.started = false;
                    this.disconnectAllOutlets();
                    this.stopSelectorObservers();
                    this.stopAttributeObservers();
                }
            }
        },
        {
            key: "stopSelectorObservers",
            value: function stopSelectorObservers() {
                if (this.selectorObserverMap.size > 0) {
                    this.selectorObserverMap.forEach(function(observer) {
                        return observer.stop();
                    });
                    this.selectorObserverMap.clear();
                }
            }
        },
        {
            key: "stopAttributeObservers",
            value: function stopAttributeObservers() {
                if (this.attributeObserverMap.size > 0) {
                    this.attributeObserverMap.forEach(function(observer) {
                        return observer.stop();
                    });
                    this.attributeObserverMap.clear();
                }
            }
        },
        {
            key: "selectorMatched",
            value: function selectorMatched(element, _selector, param) {
                var outletName = param.outletName;
                var outlet = this.getOutlet(element, outletName);
                if (outlet) this.connectOutlet(outlet, element, outletName);
            }
        },
        {
            key: "selectorUnmatched",
            value: function selectorUnmatched(element, _selector, param) {
                var outletName = param.outletName;
                var outlet = this.getOutletFromMap(element, outletName);
                if (outlet) this.disconnectOutlet(outlet, element, outletName);
            }
        },
        {
            key: "selectorMatchElement",
            value: function selectorMatchElement(element, param) {
                var outletName = param.outletName;
                var selector = this.selector(outletName);
                var hasOutlet = this.hasOutlet(element, outletName);
                var hasOutletController = element.matches("[".concat(this.schema.controllerAttribute, "~=").concat(outletName, "]"));
                if (selector) return hasOutlet && hasOutletController && element.matches(selector);
                else return false;
            }
        },
        {
            key: "elementMatchedAttribute",
            value: function elementMatchedAttribute(_element, attributeName) {
                var outletName = this.getOutletNameFromOutletAttributeName(attributeName);
                if (outletName) this.updateSelectorObserverForOutlet(outletName);
            }
        },
        {
            key: "elementAttributeValueChanged",
            value: function elementAttributeValueChanged(_element, attributeName) {
                var outletName = this.getOutletNameFromOutletAttributeName(attributeName);
                if (outletName) this.updateSelectorObserverForOutlet(outletName);
            }
        },
        {
            key: "elementUnmatchedAttribute",
            value: function elementUnmatchedAttribute(_element, attributeName) {
                var outletName = this.getOutletNameFromOutletAttributeName(attributeName);
                if (outletName) this.updateSelectorObserverForOutlet(outletName);
            }
        },
        {
            key: "connectOutlet",
            value: function connectOutlet(outlet, element, outletName) {
                var _this = this;
                var _a;
                if (!this.outletElementsByName.has(outletName, element)) {
                    this.outletsByName.add(outletName, outlet);
                    this.outletElementsByName.add(outletName, element);
                    (_a = this.selectorObserverMap.get(outletName)) === null || _a === void 0 || _a.pause(function() {
                        return _this.delegate.outletConnected(outlet, element, outletName);
                    });
                }
            }
        },
        {
            key: "disconnectOutlet",
            value: function disconnectOutlet(outlet, element, outletName) {
                var _this = this;
                var _a;
                if (this.outletElementsByName.has(outletName, element)) {
                    this.outletsByName.delete(outletName, outlet);
                    this.outletElementsByName.delete(outletName, element);
                    (_a = this.selectorObserverMap.get(outletName)) === null || _a === void 0 || _a.pause(function() {
                        return _this.delegate.outletDisconnected(outlet, element, outletName);
                    });
                }
            }
        },
        {
            key: "disconnectAllOutlets",
            value: function disconnectAllOutlets() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.outletElementsByName.keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var outletName = _step.value;
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined, _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                        try {
                            for(var _iterator1 = this.outletElementsByName.getValuesForKey(outletName)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion2 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion2 = true){
                                var element = _step1.value;
                                try {
                                    for(var _iterator2 = this.outletsByName.getValuesForKey(outletName)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion1 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion1 = true){
                                        var outlet = _step2.value;
                                        this.disconnectOutlet(outlet, element, outletName);
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator2.return != null) {
                                            _iterator2.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "updateSelectorObserverForOutlet",
            value: function updateSelectorObserverForOutlet(outletName) {
                var observer = this.selectorObserverMap.get(outletName);
                if (observer) observer.selector = this.selector(outletName);
            }
        },
        {
            key: "setupSelectorObserverForOutlet",
            value: function setupSelectorObserverForOutlet(outletName) {
                var selector = this.selector(outletName);
                var selectorObserver = new $8366b7adf73549a0$export$116e0b48509995b(document.body, selector, this, {
                    outletName: outletName
                });
                this.selectorObserverMap.set(outletName, selectorObserver);
                selectorObserver.start();
            }
        },
        {
            key: "setupAttributeObserverForOutlet",
            value: function setupAttributeObserverForOutlet(outletName) {
                var attributeName = this.attributeNameForOutletName(outletName);
                var attributeObserver = new $8366b7adf73549a0$export$fe68319d413d05cb(this.scope.element, attributeName, this);
                this.attributeObserverMap.set(outletName, attributeObserver);
                attributeObserver.start();
            }
        },
        {
            key: "selector",
            value: function selector(outletName) {
                return this.scope.outlets.getSelectorForOutletName(outletName);
            }
        },
        {
            key: "attributeNameForOutletName",
            value: function attributeNameForOutletName(outletName) {
                return this.scope.schema.outletAttributeForScope(this.identifier, outletName);
            }
        },
        {
            key: "getOutletNameFromOutletAttributeName",
            value: function getOutletNameFromOutletAttributeName(attributeName) {
                var _this = this;
                return this.outletDefinitions.find(function(outletName) {
                    return _this.attributeNameForOutletName(outletName) === attributeName;
                });
            }
        },
        {
            key: "outletDependencies",
            get: function get() {
                var dependencies = new $8366b7adf73549a0$export$8bd4ad37b76db6ba();
                this.router.modules.forEach(function(module) {
                    var constructor = module.definition.controllerConstructor;
                    var outlets = $8366b7adf73549a0$var$readInheritableStaticArrayValues(constructor, "outlets");
                    outlets.forEach(function(outlet) {
                        return dependencies.add(outlet, module.identifier);
                    });
                });
                return dependencies;
            }
        },
        {
            key: "outletDefinitions",
            get: function get() {
                return this.outletDependencies.getKeysForValue(this.identifier);
            }
        },
        {
            key: "dependentControllerIdentifiers",
            get: function get() {
                return this.outletDependencies.getValuesForKey(this.identifier);
            }
        },
        {
            key: "dependentContexts",
            get: function get() {
                var identifiers = this.dependentControllerIdentifiers;
                return this.router.contexts.filter(function(context) {
                    return identifiers.includes(context.identifier);
                });
            }
        },
        {
            key: "hasOutlet",
            value: function hasOutlet(element, outletName) {
                return !!this.getOutlet(element, outletName) || !!this.getOutletFromMap(element, outletName);
            }
        },
        {
            key: "getOutlet",
            value: function getOutlet(element, outletName) {
                return this.application.getControllerForElementAndIdentifier(element, outletName);
            }
        },
        {
            key: "getOutletFromMap",
            value: function getOutletFromMap(element, outletName) {
                return this.outletsByName.getValuesForKey(outletName).find(function(outlet) {
                    return outlet.element === element;
                });
            }
        },
        {
            key: "scope",
            get: function get() {
                return this.context.scope;
            }
        },
        {
            key: "schema",
            get: function get() {
                return this.context.schema;
            }
        },
        {
            key: "identifier",
            get: function get() {
                return this.context.identifier;
            }
        },
        {
            key: "application",
            get: function get() {
                return this.context.application;
            }
        },
        {
            key: "router",
            get: function get() {
                return this.application.router;
            }
        }
    ]);
    return OutletObserver;
}();
var $8366b7adf73549a0$export$841858b892ce1f4c = /*#__PURE__*/ function() {
    "use strict";
    function Context(module, scope) {
        var _this = this;
        (0, $9j09T._)(this, Context);
        this.logDebugActivity = function(functionName) {
            var detail = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            var identifier = _this.identifier, controller = _this.controller, element = _this.element;
            detail = Object.assign({
                identifier: identifier,
                controller: controller,
                element: element
            }, detail);
            _this.application.logDebugActivity(_this.identifier, functionName, detail);
        };
        this.module = module;
        this.scope = scope;
        this.controller = new module.controllerConstructor(this);
        this.bindingObserver = new $8366b7adf73549a0$var$BindingObserver(this, this.dispatcher);
        this.valueObserver = new $8366b7adf73549a0$var$ValueObserver(this, this.controller);
        this.targetObserver = new $8366b7adf73549a0$var$TargetObserver(this, this);
        this.outletObserver = new $8366b7adf73549a0$var$OutletObserver(this, this);
        try {
            this.controller.initialize();
            this.logDebugActivity("initialize");
        } catch (error) {
            this.handleError(error, "initializing controller");
        }
    }
    (0, $eDeHT._)(Context, [
        {
            key: "connect",
            value: function connect() {
                this.bindingObserver.start();
                this.valueObserver.start();
                this.targetObserver.start();
                this.outletObserver.start();
                try {
                    this.controller.connect();
                    this.logDebugActivity("connect");
                } catch (error) {
                    this.handleError(error, "connecting controller");
                }
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                this.outletObserver.refresh();
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                try {
                    this.controller.disconnect();
                    this.logDebugActivity("disconnect");
                } catch (error) {
                    this.handleError(error, "disconnecting controller");
                }
                this.outletObserver.stop();
                this.targetObserver.stop();
                this.valueObserver.stop();
                this.bindingObserver.stop();
            }
        },
        {
            key: "application",
            get: function get() {
                return this.module.application;
            }
        },
        {
            key: "identifier",
            get: function get() {
                return this.module.identifier;
            }
        },
        {
            key: "schema",
            get: function get() {
                return this.application.schema;
            }
        },
        {
            key: "dispatcher",
            get: function get() {
                return this.application.dispatcher;
            }
        },
        {
            key: "element",
            get: function get() {
                return this.scope.element;
            }
        },
        {
            key: "parentElement",
            get: function get() {
                return this.element.parentElement;
            }
        },
        {
            key: "handleError",
            value: function handleError(error, message) {
                var detail = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this = this, identifier = _this.identifier, controller = _this.controller, element = _this.element;
                detail = Object.assign({
                    identifier: identifier,
                    controller: controller,
                    element: element
                }, detail);
                this.application.handleError(error, "Error ".concat(message), detail);
            }
        },
        {
            key: "targetConnected",
            value: function targetConnected(element, name) {
                this.invokeControllerMethod("".concat(name, "TargetConnected"), element);
            }
        },
        {
            key: "targetDisconnected",
            value: function targetDisconnected(element, name) {
                this.invokeControllerMethod("".concat(name, "TargetDisconnected"), element);
            }
        },
        {
            key: "outletConnected",
            value: function outletConnected(outlet, element, name) {
                this.invokeControllerMethod("".concat($8366b7adf73549a0$var$namespaceCamelize(name), "OutletConnected"), outlet, element);
            }
        },
        {
            key: "outletDisconnected",
            value: function outletDisconnected(outlet, element, name) {
                this.invokeControllerMethod("".concat($8366b7adf73549a0$var$namespaceCamelize(name), "OutletDisconnected"), outlet, element);
            }
        },
        {
            key: "invokeControllerMethod",
            value: function invokeControllerMethod(methodName) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                var _controller;
                var controller = this.controller;
                if (typeof controller[methodName] == "function") (_controller = controller)[methodName].apply(_controller, (0, $enL5v._)(args));
            }
        }
    ]);
    return Context;
}();
function $8366b7adf73549a0$var$bless(constructor) {
    return $8366b7adf73549a0$var$shadow(constructor, $8366b7adf73549a0$var$getBlessedProperties(constructor));
}
function $8366b7adf73549a0$var$shadow(constructor, properties) {
    var shadowConstructor = $8366b7adf73549a0$var$extend(constructor);
    var shadowProperties = $8366b7adf73549a0$var$getShadowProperties(constructor.prototype, properties);
    Object.defineProperties(shadowConstructor.prototype, shadowProperties);
    return shadowConstructor;
}
function $8366b7adf73549a0$var$getBlessedProperties(constructor) {
    var blessings = $8366b7adf73549a0$var$readInheritableStaticArrayValues(constructor, "blessings");
    return blessings.reduce(function(blessedProperties, blessing) {
        var properties = blessing(constructor);
        for(var key in properties){
            var descriptor = blessedProperties[key] || {};
            blessedProperties[key] = Object.assign(descriptor, properties[key]);
        }
        return blessedProperties;
    }, {});
}
function $8366b7adf73549a0$var$getShadowProperties(prototype, properties) {
    return $8366b7adf73549a0$var$getOwnKeys(properties).reduce(function(shadowProperties, key) {
        var descriptor = $8366b7adf73549a0$var$getShadowedDescriptor(prototype, properties, key);
        if (descriptor) Object.assign(shadowProperties, (0, $Npnks._)({}, key, descriptor));
        return shadowProperties;
    }, {});
}
function $8366b7adf73549a0$var$getShadowedDescriptor(prototype, properties, key) {
    var shadowingDescriptor = Object.getOwnPropertyDescriptor(prototype, key);
    var shadowedByValue = shadowingDescriptor && "value" in shadowingDescriptor;
    if (!shadowedByValue) {
        var descriptor = Object.getOwnPropertyDescriptor(properties, key).value;
        if (shadowingDescriptor) {
            descriptor.get = shadowingDescriptor.get || descriptor.get;
            descriptor.set = shadowingDescriptor.set || descriptor.set;
        }
        return descriptor;
    }
}
var $8366b7adf73549a0$var$getOwnKeys = function() {
    if (typeof Object.getOwnPropertySymbols == "function") return function(object) {
        return (0, $enL5v._)(Object.getOwnPropertyNames(object)).concat((0, $enL5v._)(Object.getOwnPropertySymbols(object)));
    };
    else return Object.getOwnPropertyNames;
}();
var $8366b7adf73549a0$var$extend = function _target() {
    function extendWithReflect(constructor) {
        function extended() {
            return Reflect.construct(constructor, arguments, this instanceof extended ? this.constructor : void 0);
        }
        extended.prototype = Object.create(constructor.prototype, {
            constructor: {
                value: extended
            }
        });
        Reflect.setPrototypeOf(extended, constructor);
        return extended;
    }
    function testReflectExtension() {
        var a = function a() {
            this.a.call(this);
        };
        var b = extendWithReflect(a);
        b.prototype.a = function() {};
        return new b();
    }
    try {
        testReflectExtension();
        return extendWithReflect;
    } catch (error) {
        return function(constructor) {
            return /*#__PURE__*/ function(constructor) {
                "use strict";
                (0, $i0LXg._)(extended, constructor);
                var _super = (0, $a1vXf._)(extended);
                function extended() {
                    (0, $9j09T._)(this, extended);
                    return _super.apply(this, arguments);
                }
                return extended;
            }(constructor);
        };
    }
}();
function $8366b7adf73549a0$var$blessDefinition(definition) {
    return {
        identifier: definition.identifier,
        controllerConstructor: $8366b7adf73549a0$var$bless(definition.controllerConstructor)
    };
}
var $8366b7adf73549a0$var$Module = /*#__PURE__*/ function() {
    "use strict";
    function Module(application, definition) {
        (0, $9j09T._)(this, Module);
        this.application = application;
        this.definition = $8366b7adf73549a0$var$blessDefinition(definition);
        this.contextsByScope = new WeakMap();
        this.connectedContexts = new Set();
    }
    (0, $eDeHT._)(Module, [
        {
            key: "identifier",
            get: function get() {
                return this.definition.identifier;
            }
        },
        {
            key: "controllerConstructor",
            get: function get() {
                return this.definition.controllerConstructor;
            }
        },
        {
            key: "contexts",
            get: function get() {
                return Array.from(this.connectedContexts);
            }
        },
        {
            key: "connectContextForScope",
            value: function connectContextForScope(scope) {
                var context = this.fetchContextForScope(scope);
                this.connectedContexts.add(context);
                context.connect();
            }
        },
        {
            key: "disconnectContextForScope",
            value: function disconnectContextForScope(scope) {
                var context = this.contextsByScope.get(scope);
                if (context) {
                    this.connectedContexts.delete(context);
                    context.disconnect();
                }
            }
        },
        {
            key: "fetchContextForScope",
            value: function fetchContextForScope(scope) {
                var context = this.contextsByScope.get(scope);
                if (!context) {
                    context = new $8366b7adf73549a0$export$841858b892ce1f4c(this, scope);
                    this.contextsByScope.set(scope, context);
                }
                return context;
            }
        }
    ]);
    return Module;
}();
var $8366b7adf73549a0$var$ClassMap = /*#__PURE__*/ function() {
    "use strict";
    function ClassMap(scope) {
        (0, $9j09T._)(this, ClassMap);
        this.scope = scope;
    }
    (0, $eDeHT._)(ClassMap, [
        {
            key: "has",
            value: function has(name) {
                return this.data.has(this.getDataKey(name));
            }
        },
        {
            key: "get",
            value: function get(name) {
                return this.getAll(name)[0];
            }
        },
        {
            key: "getAll",
            value: function getAll(name) {
                var tokenString = this.data.get(this.getDataKey(name)) || "";
                return $8366b7adf73549a0$var$tokenize(tokenString);
            }
        },
        {
            key: "getAttributeName",
            value: function getAttributeName(name) {
                return this.data.getAttributeNameForKey(this.getDataKey(name));
            }
        },
        {
            key: "getDataKey",
            value: function getDataKey(name) {
                return "".concat(name, "-class");
            }
        },
        {
            key: "data",
            get: function get() {
                return this.scope.data;
            }
        }
    ]);
    return ClassMap;
}();
var $8366b7adf73549a0$var$DataMap = /*#__PURE__*/ function() {
    "use strict";
    function DataMap(scope) {
        (0, $9j09T._)(this, DataMap);
        this.scope = scope;
    }
    (0, $eDeHT._)(DataMap, [
        {
            key: "element",
            get: function get() {
                return this.scope.element;
            }
        },
        {
            key: "identifier",
            get: function get() {
                return this.scope.identifier;
            }
        },
        {
            key: "get",
            value: function get(key) {
                var name = this.getAttributeNameForKey(key);
                return this.element.getAttribute(name);
            }
        },
        {
            key: "set",
            value: function set(key, value) {
                var name = this.getAttributeNameForKey(key);
                this.element.setAttribute(name, value);
                return this.get(key);
            }
        },
        {
            key: "has",
            value: function has(key) {
                var name = this.getAttributeNameForKey(key);
                return this.element.hasAttribute(name);
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                if (this.has(key)) {
                    var name = this.getAttributeNameForKey(key);
                    this.element.removeAttribute(name);
                    return true;
                } else return false;
            }
        },
        {
            key: "getAttributeNameForKey",
            value: function getAttributeNameForKey(key) {
                return "data-".concat(this.identifier, "-").concat($8366b7adf73549a0$var$dasherize(key));
            }
        }
    ]);
    return DataMap;
}();
var $8366b7adf73549a0$var$Guide = /*#__PURE__*/ function() {
    "use strict";
    function Guide(logger) {
        (0, $9j09T._)(this, Guide);
        this.warnedKeysByObject = new WeakMap();
        this.logger = logger;
    }
    (0, $eDeHT._)(Guide, [
        {
            key: "warn",
            value: function warn(object, key, message) {
                var warnedKeys = this.warnedKeysByObject.get(object);
                if (!warnedKeys) {
                    warnedKeys = new Set();
                    this.warnedKeysByObject.set(object, warnedKeys);
                }
                if (!warnedKeys.has(key)) {
                    warnedKeys.add(key);
                    this.logger.warn(message, object);
                }
            }
        }
    ]);
    return Guide;
}();
function $8366b7adf73549a0$var$attributeValueContainsToken(attributeName, token) {
    return "[".concat(attributeName, '~="').concat(token, '"]');
}
var $8366b7adf73549a0$var$TargetSet = /*#__PURE__*/ function() {
    "use strict";
    function TargetSet(scope) {
        (0, $9j09T._)(this, TargetSet);
        this.scope = scope;
    }
    (0, $eDeHT._)(TargetSet, [
        {
            key: "element",
            get: function get() {
                return this.scope.element;
            }
        },
        {
            key: "identifier",
            get: function get() {
                return this.scope.identifier;
            }
        },
        {
            key: "schema",
            get: function get() {
                return this.scope.schema;
            }
        },
        {
            key: "has",
            value: function has(targetName) {
                return this.find(targetName) != null;
            }
        },
        {
            key: "find",
            value: function find() {
                for(var _len = arguments.length, targetNames = new Array(_len), _key = 0; _key < _len; _key++){
                    targetNames[_key] = arguments[_key];
                }
                var _this = this;
                return targetNames.reduce(function(target, targetName) {
                    return target || _this.findTarget(targetName) || _this.findLegacyTarget(targetName);
                }, undefined);
            }
        },
        {
            key: "findAll",
            value: function findAll() {
                for(var _len = arguments.length, targetNames = new Array(_len), _key = 0; _key < _len; _key++){
                    targetNames[_key] = arguments[_key];
                }
                var _this = this;
                return targetNames.reduce(function(targets, targetName) {
                    return (0, $enL5v._)(targets).concat((0, $enL5v._)(_this.findAllTargets(targetName)), (0, $enL5v._)(_this.findAllLegacyTargets(targetName)));
                }, []);
            }
        },
        {
            key: "findTarget",
            value: function findTarget(targetName) {
                var selector = this.getSelectorForTargetName(targetName);
                return this.scope.findElement(selector);
            }
        },
        {
            key: "findAllTargets",
            value: function findAllTargets(targetName) {
                var selector = this.getSelectorForTargetName(targetName);
                return this.scope.findAllElements(selector);
            }
        },
        {
            key: "getSelectorForTargetName",
            value: function getSelectorForTargetName(targetName) {
                var attributeName = this.schema.targetAttributeForScope(this.identifier);
                return $8366b7adf73549a0$var$attributeValueContainsToken(attributeName, targetName);
            }
        },
        {
            key: "findLegacyTarget",
            value: function findLegacyTarget(targetName) {
                var selector = this.getLegacySelectorForTargetName(targetName);
                return this.deprecate(this.scope.findElement(selector), targetName);
            }
        },
        {
            key: "findAllLegacyTargets",
            value: function findAllLegacyTargets(targetName) {
                var _this = this;
                var selector = this.getLegacySelectorForTargetName(targetName);
                return this.scope.findAllElements(selector).map(function(element) {
                    return _this.deprecate(element, targetName);
                });
            }
        },
        {
            key: "getLegacySelectorForTargetName",
            value: function getLegacySelectorForTargetName(targetName) {
                var targetDescriptor = "".concat(this.identifier, ".").concat(targetName);
                return $8366b7adf73549a0$var$attributeValueContainsToken(this.schema.targetAttribute, targetDescriptor);
            }
        },
        {
            key: "deprecate",
            value: function deprecate(element, targetName) {
                if (element) {
                    var identifier = this.identifier;
                    var attributeName = this.schema.targetAttribute;
                    var revisedAttributeName = this.schema.targetAttributeForScope(identifier);
                    this.guide.warn(element, "target:".concat(targetName), "Please replace ".concat(attributeName, '="').concat(identifier, ".").concat(targetName, '" with ').concat(revisedAttributeName, '="').concat(targetName, '". ') + "The ".concat(attributeName, " attribute is deprecated and will be removed in a future version of Stimulus."));
                }
                return element;
            }
        },
        {
            key: "guide",
            get: function get() {
                return this.scope.guide;
            }
        }
    ]);
    return TargetSet;
}();
var $8366b7adf73549a0$var$OutletSet = /*#__PURE__*/ function() {
    "use strict";
    function OutletSet(scope, controllerElement) {
        (0, $9j09T._)(this, OutletSet);
        this.scope = scope;
        this.controllerElement = controllerElement;
    }
    (0, $eDeHT._)(OutletSet, [
        {
            key: "element",
            get: function get() {
                return this.scope.element;
            }
        },
        {
            key: "identifier",
            get: function get() {
                return this.scope.identifier;
            }
        },
        {
            key: "schema",
            get: function get() {
                return this.scope.schema;
            }
        },
        {
            key: "has",
            value: function has(outletName) {
                return this.find(outletName) != null;
            }
        },
        {
            key: "find",
            value: function find() {
                for(var _len = arguments.length, outletNames = new Array(_len), _key = 0; _key < _len; _key++){
                    outletNames[_key] = arguments[_key];
                }
                var _this = this;
                return outletNames.reduce(function(outlet, outletName) {
                    return outlet || _this.findOutlet(outletName);
                }, undefined);
            }
        },
        {
            key: "findAll",
            value: function findAll() {
                for(var _len = arguments.length, outletNames = new Array(_len), _key = 0; _key < _len; _key++){
                    outletNames[_key] = arguments[_key];
                }
                var _this = this;
                return outletNames.reduce(function(outlets, outletName) {
                    return (0, $enL5v._)(outlets).concat((0, $enL5v._)(_this.findAllOutlets(outletName)));
                }, []);
            }
        },
        {
            key: "getSelectorForOutletName",
            value: function getSelectorForOutletName(outletName) {
                var attributeName = this.schema.outletAttributeForScope(this.identifier, outletName);
                return this.controllerElement.getAttribute(attributeName);
            }
        },
        {
            key: "findOutlet",
            value: function findOutlet(outletName) {
                var selector = this.getSelectorForOutletName(outletName);
                if (selector) return this.findElement(selector, outletName);
            }
        },
        {
            key: "findAllOutlets",
            value: function findAllOutlets(outletName) {
                var selector = this.getSelectorForOutletName(outletName);
                return selector ? this.findAllElements(selector, outletName) : [];
            }
        },
        {
            key: "findElement",
            value: function findElement(selector, outletName) {
                var _this = this;
                var elements = this.scope.queryElements(selector);
                return elements.filter(function(element) {
                    return _this.matchesElement(element, selector, outletName);
                })[0];
            }
        },
        {
            key: "findAllElements",
            value: function findAllElements(selector, outletName) {
                var _this = this;
                var elements = this.scope.queryElements(selector);
                return elements.filter(function(element) {
                    return _this.matchesElement(element, selector, outletName);
                });
            }
        },
        {
            key: "matchesElement",
            value: function matchesElement(element, selector, outletName) {
                var controllerAttribute = element.getAttribute(this.scope.schema.controllerAttribute) || "";
                return element.matches(selector) && controllerAttribute.split(" ").includes(outletName);
            }
        }
    ]);
    return OutletSet;
}();
var $8366b7adf73549a0$var$Scope = /*#__PURE__*/ function() {
    "use strict";
    function Scope(schema, element, identifier, logger) {
        var _this = this;
        (0, $9j09T._)(this, Scope);
        this.targets = new $8366b7adf73549a0$var$TargetSet(this);
        this.classes = new $8366b7adf73549a0$var$ClassMap(this);
        this.data = new $8366b7adf73549a0$var$DataMap(this);
        this.containsElement = function(element) {
            return element.closest(_this.controllerSelector) === _this.element;
        };
        this.schema = schema;
        this.element = element;
        this.identifier = identifier;
        this.guide = new $8366b7adf73549a0$var$Guide(logger);
        this.outlets = new $8366b7adf73549a0$var$OutletSet(this.documentScope, element);
    }
    (0, $eDeHT._)(Scope, [
        {
            key: "findElement",
            value: function findElement(selector) {
                return this.element.matches(selector) ? this.element : this.queryElements(selector).find(this.containsElement);
            }
        },
        {
            key: "findAllElements",
            value: function findAllElements(selector) {
                return (0, $enL5v._)(this.element.matches(selector) ? [
                    this.element
                ] : []).concat((0, $enL5v._)(this.queryElements(selector).filter(this.containsElement)));
            }
        },
        {
            key: "queryElements",
            value: function queryElements(selector) {
                return Array.from(this.element.querySelectorAll(selector));
            }
        },
        {
            key: "controllerSelector",
            get: function get() {
                return $8366b7adf73549a0$var$attributeValueContainsToken(this.schema.controllerAttribute, this.identifier);
            }
        },
        {
            key: "isDocumentScope",
            get: function get() {
                return this.element === document.documentElement;
            }
        },
        {
            key: "documentScope",
            get: function get() {
                return this.isDocumentScope ? this : new Scope(this.schema, document.documentElement, this.identifier, this.guide.logger);
            }
        }
    ]);
    return Scope;
}();
var $8366b7adf73549a0$var$ScopeObserver = /*#__PURE__*/ function() {
    "use strict";
    function ScopeObserver(element, schema, delegate) {
        (0, $9j09T._)(this, ScopeObserver);
        this.element = element;
        this.schema = schema;
        this.delegate = delegate;
        this.valueListObserver = new $8366b7adf73549a0$export$d27fa4c7330a452e(this.element, this.controllerAttribute, this);
        this.scopesByIdentifierByElement = new WeakMap();
        this.scopeReferenceCounts = new WeakMap();
    }
    (0, $eDeHT._)(ScopeObserver, [
        {
            key: "start",
            value: function start() {
                this.valueListObserver.start();
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.valueListObserver.stop();
            }
        },
        {
            key: "controllerAttribute",
            get: function get() {
                return this.schema.controllerAttribute;
            }
        },
        {
            key: "parseValueForToken",
            value: function parseValueForToken(token) {
                var element = token.element, identifier = token.content;
                return this.parseValueForElementAndIdentifier(element, identifier);
            }
        },
        {
            key: "parseValueForElementAndIdentifier",
            value: function parseValueForElementAndIdentifier(element, identifier) {
                var scopesByIdentifier = this.fetchScopesByIdentifierForElement(element);
                var scope = scopesByIdentifier.get(identifier);
                if (!scope) {
                    scope = this.delegate.createScopeForElementAndIdentifier(element, identifier);
                    scopesByIdentifier.set(identifier, scope);
                }
                return scope;
            }
        },
        {
            key: "elementMatchedValue",
            value: function elementMatchedValue(element, value) {
                var referenceCount = (this.scopeReferenceCounts.get(value) || 0) + 1;
                this.scopeReferenceCounts.set(value, referenceCount);
                if (referenceCount == 1) this.delegate.scopeConnected(value);
            }
        },
        {
            key: "elementUnmatchedValue",
            value: function elementUnmatchedValue(element, value) {
                var referenceCount = this.scopeReferenceCounts.get(value);
                if (referenceCount) {
                    this.scopeReferenceCounts.set(value, referenceCount - 1);
                    if (referenceCount == 1) this.delegate.scopeDisconnected(value);
                }
            }
        },
        {
            key: "fetchScopesByIdentifierForElement",
            value: function fetchScopesByIdentifierForElement(element) {
                var scopesByIdentifier = this.scopesByIdentifierByElement.get(element);
                if (!scopesByIdentifier) {
                    scopesByIdentifier = new Map();
                    this.scopesByIdentifierByElement.set(element, scopesByIdentifier);
                }
                return scopesByIdentifier;
            }
        }
    ]);
    return ScopeObserver;
}();
var $8366b7adf73549a0$var$Router = /*#__PURE__*/ function() {
    "use strict";
    function Router(application) {
        (0, $9j09T._)(this, Router);
        this.application = application;
        this.scopeObserver = new $8366b7adf73549a0$var$ScopeObserver(this.element, this.schema, this);
        this.scopesByIdentifier = new $8366b7adf73549a0$export$8bd4ad37b76db6ba();
        this.modulesByIdentifier = new Map();
    }
    (0, $eDeHT._)(Router, [
        {
            key: "element",
            get: function get() {
                return this.application.element;
            }
        },
        {
            key: "schema",
            get: function get() {
                return this.application.schema;
            }
        },
        {
            key: "logger",
            get: function get() {
                return this.application.logger;
            }
        },
        {
            key: "controllerAttribute",
            get: function get() {
                return this.schema.controllerAttribute;
            }
        },
        {
            key: "modules",
            get: function get() {
                return Array.from(this.modulesByIdentifier.values());
            }
        },
        {
            key: "contexts",
            get: function get() {
                return this.modules.reduce(function(contexts, module) {
                    return contexts.concat(module.contexts);
                }, []);
            }
        },
        {
            key: "start",
            value: function start() {
                this.scopeObserver.start();
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.scopeObserver.stop();
            }
        },
        {
            key: "loadDefinition",
            value: function loadDefinition(definition) {
                this.unloadIdentifier(definition.identifier);
                var module = new $8366b7adf73549a0$var$Module(this.application, definition);
                this.connectModule(module);
                var afterLoad = definition.controllerConstructor.afterLoad;
                if (afterLoad) afterLoad.call(definition.controllerConstructor, definition.identifier, this.application);
            }
        },
        {
            key: "unloadIdentifier",
            value: function unloadIdentifier(identifier) {
                var module = this.modulesByIdentifier.get(identifier);
                if (module) this.disconnectModule(module);
            }
        },
        {
            key: "getContextForElementAndIdentifier",
            value: function getContextForElementAndIdentifier(element, identifier) {
                var module = this.modulesByIdentifier.get(identifier);
                if (module) return module.contexts.find(function(context) {
                    return context.element == element;
                });
            }
        },
        {
            key: "proposeToConnectScopeForElementAndIdentifier",
            value: function proposeToConnectScopeForElementAndIdentifier(element, identifier) {
                var scope = this.scopeObserver.parseValueForElementAndIdentifier(element, identifier);
                if (scope) this.scopeObserver.elementMatchedValue(scope.element, scope);
                else console.error("Couldn't find or create scope for identifier: \"".concat(identifier, '" and element:'), element);
            }
        },
        {
            key: "handleError",
            value: function handleError(error, message, detail) {
                this.application.handleError(error, message, detail);
            }
        },
        {
            key: "createScopeForElementAndIdentifier",
            value: function createScopeForElementAndIdentifier(element, identifier) {
                return new $8366b7adf73549a0$var$Scope(this.schema, element, identifier, this.logger);
            }
        },
        {
            key: "scopeConnected",
            value: function scopeConnected(scope) {
                this.scopesByIdentifier.add(scope.identifier, scope);
                var module = this.modulesByIdentifier.get(scope.identifier);
                if (module) module.connectContextForScope(scope);
            }
        },
        {
            key: "scopeDisconnected",
            value: function scopeDisconnected(scope) {
                this.scopesByIdentifier.delete(scope.identifier, scope);
                var module = this.modulesByIdentifier.get(scope.identifier);
                if (module) module.disconnectContextForScope(scope);
            }
        },
        {
            key: "connectModule",
            value: function connectModule(module) {
                this.modulesByIdentifier.set(module.identifier, module);
                var scopes = this.scopesByIdentifier.getValuesForKey(module.identifier);
                scopes.forEach(function(scope) {
                    return module.connectContextForScope(scope);
                });
            }
        },
        {
            key: "disconnectModule",
            value: function disconnectModule(module) {
                this.modulesByIdentifier.delete(module.identifier);
                var scopes = this.scopesByIdentifier.getValuesForKey(module.identifier);
                scopes.forEach(function(scope) {
                    return module.disconnectContextForScope(scope);
                });
            }
        }
    ]);
    return Router;
}();
var $8366b7adf73549a0$export$1db618b7b2275ea1 = {
    controllerAttribute: "data-controller",
    actionAttribute: "data-action",
    targetAttribute: "data-target",
    targetAttributeForScope: function(identifier) {
        return "data-".concat(identifier, "-target");
    },
    outletAttributeForScope: function(identifier, outlet) {
        return "data-".concat(identifier, "-").concat(outlet, "-outlet");
    },
    keyMappings: Object.assign(Object.assign({
        enter: "Enter",
        tab: "Tab",
        esc: "Escape",
        space: " ",
        up: "ArrowUp",
        down: "ArrowDown",
        left: "ArrowLeft",
        right: "ArrowRight",
        home: "Home",
        end: "End",
        page_up: "PageUp",
        page_down: "PageDown"
    }, $8366b7adf73549a0$var$objectFromEntries("abcdefghijklmnopqrstuvwxyz".split("").map(function(c) {
        return [
            c,
            c
        ];
    }))), $8366b7adf73549a0$var$objectFromEntries("0123456789".split("").map(function(n) {
        return [
            n,
            n
        ];
    })))
};
function $8366b7adf73549a0$var$objectFromEntries(array) {
    return array.reduce(function(memo, param) {
        var _param = (0, $fyOZQ._)(param, 2), k = _param[0], v = _param[1];
        return Object.assign(Object.assign({}, memo), (0, $Npnks._)({}, k, v));
    }, {});
}
var $8366b7adf73549a0$export$16975c34e60e1e61 = /*#__PURE__*/ function() {
    "use strict";
    function Application() {
        var element = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document.documentElement, schema = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $8366b7adf73549a0$export$1db618b7b2275ea1;
        var _this = this;
        (0, $9j09T._)(this, Application);
        this.logger = console;
        this.debug = false;
        this.logDebugActivity = function(identifier, functionName) {
            var detail = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            if (_this.debug) _this.logFormattedMessage(identifier, functionName, detail);
        };
        this.element = element;
        this.schema = schema;
        this.dispatcher = new $8366b7adf73549a0$var$Dispatcher(this);
        this.router = new $8366b7adf73549a0$var$Router(this);
        this.actionDescriptorFilters = Object.assign({}, $8366b7adf73549a0$var$defaultActionDescriptorFilters);
    }
    (0, $eDeHT._)(Application, [
        {
            key: "start",
            value: function start() {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $8366b7adf73549a0$var$domReady()
                                ];
                            case 1:
                                _state.sent();
                                _this.logDebugActivity("application", "starting");
                                _this.dispatcher.start();
                                _this.router.start();
                                _this.logDebugActivity("application", "start");
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.logDebugActivity("application", "stopping");
                this.dispatcher.stop();
                this.router.stop();
                this.logDebugActivity("application", "stop");
            }
        },
        {
            key: "register",
            value: function register(identifier, controllerConstructor) {
                this.load({
                    identifier: identifier,
                    controllerConstructor: controllerConstructor
                });
            }
        },
        {
            key: "registerActionOption",
            value: function registerActionOption(name, filter) {
                this.actionDescriptorFilters[name] = filter;
            }
        },
        {
            key: "load",
            value: function load(head) {
                for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    rest[_key - 1] = arguments[_key];
                }
                var _this = this;
                var definitions = Array.isArray(head) ? head : [
                    head
                ].concat((0, $enL5v._)(rest));
                definitions.forEach(function(definition) {
                    if (definition.controllerConstructor.shouldLoad) _this.router.loadDefinition(definition);
                });
            }
        },
        {
            key: "unload",
            value: function unload(head) {
                for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    rest[_key - 1] = arguments[_key];
                }
                var _this = this;
                var identifiers = Array.isArray(head) ? head : [
                    head
                ].concat((0, $enL5v._)(rest));
                identifiers.forEach(function(identifier) {
                    return _this.router.unloadIdentifier(identifier);
                });
            }
        },
        {
            key: "controllers",
            get: function get() {
                return this.router.contexts.map(function(context) {
                    return context.controller;
                });
            }
        },
        {
            key: "getControllerForElementAndIdentifier",
            value: function getControllerForElementAndIdentifier(element, identifier) {
                var context = this.router.getContextForElementAndIdentifier(element, identifier);
                return context ? context.controller : null;
            }
        },
        {
            key: "handleError",
            value: function handleError(error, message, detail) {
                var _a;
                this.logger.error("%s\n\n%o\n\n%o", message, error, detail);
                (_a = window.onerror) === null || _a === void 0 || _a.call(window, message, "", 0, 0, error);
            }
        },
        {
            key: "logFormattedMessage",
            value: function logFormattedMessage(identifier, functionName) {
                var detail = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                detail = Object.assign({
                    application: this
                }, detail);
                this.logger.groupCollapsed("".concat(identifier, " #").concat(functionName));
                this.logger.log("details:", Object.assign({}, detail));
                this.logger.groupEnd();
            }
        }
    ], [
        {
            key: "start",
            value: function start(element, schema) {
                var application = new this(element, schema);
                application.start();
                return application;
            }
        }
    ]);
    return Application;
}();
function $8366b7adf73549a0$var$domReady() {
    return new Promise(function(resolve) {
        if (document.readyState == "loading") document.addEventListener("DOMContentLoaded", function() {
            return resolve();
        });
        else resolve();
    });
}
function $8366b7adf73549a0$var$ClassPropertiesBlessing(constructor) {
    var classes = $8366b7adf73549a0$var$readInheritableStaticArrayValues(constructor, "classes");
    return classes.reduce(function(properties, classDefinition) {
        return Object.assign(properties, $8366b7adf73549a0$var$propertiesForClassDefinition(classDefinition));
    }, {});
}
function $8366b7adf73549a0$var$propertiesForClassDefinition(key) {
    var _obj;
    return _obj = {}, (0, $Npnks._)(_obj, "".concat(key, "Class"), {
        get: function() {
            var classes = this.classes;
            if (classes.has(key)) return classes.get(key);
            else {
                var attribute = classes.getAttributeName(key);
                throw new Error('Missing attribute "'.concat(attribute, '"'));
            }
        }
    }), (0, $Npnks._)(_obj, "".concat(key, "Classes"), {
        get: function() {
            return this.classes.getAll(key);
        }
    }), (0, $Npnks._)(_obj, "has".concat($8366b7adf73549a0$var$capitalize(key), "Class"), {
        get: function() {
            return this.classes.has(key);
        }
    }), _obj;
}
function $8366b7adf73549a0$var$OutletPropertiesBlessing(constructor) {
    var outlets = $8366b7adf73549a0$var$readInheritableStaticArrayValues(constructor, "outlets");
    return outlets.reduce(function(properties, outletDefinition) {
        return Object.assign(properties, $8366b7adf73549a0$var$propertiesForOutletDefinition(outletDefinition));
    }, {});
}
function $8366b7adf73549a0$var$getOutletController(controller, element, identifier) {
    return controller.application.getControllerForElementAndIdentifier(element, identifier);
}
function $8366b7adf73549a0$var$getControllerAndEnsureConnectedScope(controller, element, outletName) {
    var outletController = $8366b7adf73549a0$var$getOutletController(controller, element, outletName);
    if (outletController) return outletController;
    controller.application.router.proposeToConnectScopeForElementAndIdentifier(element, outletName);
    outletController = $8366b7adf73549a0$var$getOutletController(controller, element, outletName);
    if (outletController) return outletController;
}
function $8366b7adf73549a0$var$propertiesForOutletDefinition(name) {
    var camelizedName = $8366b7adf73549a0$var$namespaceCamelize(name);
    var _obj;
    return _obj = {}, (0, $Npnks._)(_obj, "".concat(camelizedName, "Outlet"), {
        get: function() {
            var outletElement = this.outlets.find(name);
            var selector = this.outlets.getSelectorForOutletName(name);
            if (outletElement) {
                var outletController = $8366b7adf73549a0$var$getControllerAndEnsureConnectedScope(this, outletElement, name);
                if (outletController) return outletController;
                throw new Error('The provided outlet element is missing an outlet controller "'.concat(name, '" instance for host controller "').concat(this.identifier, '"'));
            }
            throw new Error('Missing outlet element "'.concat(name, '" for host controller "').concat(this.identifier, '". Stimulus couldn\'t find a matching outlet element using selector "').concat(selector, '".'));
        }
    }), (0, $Npnks._)(_obj, "".concat(camelizedName, "Outlets"), {
        get: function() {
            var _this = this;
            var outlets = this.outlets.findAll(name);
            if (outlets.length > 0) return outlets.map(function(outletElement) {
                var outletController = $8366b7adf73549a0$var$getControllerAndEnsureConnectedScope(_this, outletElement, name);
                if (outletController) return outletController;
                console.warn('The provided outlet element is missing an outlet controller "'.concat(name, '" instance for host controller "').concat(_this.identifier, '"'), outletElement);
            }).filter(function(controller) {
                return controller;
            });
            return [];
        }
    }), (0, $Npnks._)(_obj, "".concat(camelizedName, "OutletElement"), {
        get: function() {
            var outletElement = this.outlets.find(name);
            var selector = this.outlets.getSelectorForOutletName(name);
            if (outletElement) return outletElement;
            else throw new Error('Missing outlet element "'.concat(name, '" for host controller "').concat(this.identifier, '". Stimulus couldn\'t find a matching outlet element using selector "').concat(selector, '".'));
        }
    }), (0, $Npnks._)(_obj, "".concat(camelizedName, "OutletElements"), {
        get: function() {
            return this.outlets.findAll(name);
        }
    }), (0, $Npnks._)(_obj, "has".concat($8366b7adf73549a0$var$capitalize(camelizedName), "Outlet"), {
        get: function() {
            return this.outlets.has(name);
        }
    }), _obj;
}
function $8366b7adf73549a0$var$TargetPropertiesBlessing(constructor) {
    var targets = $8366b7adf73549a0$var$readInheritableStaticArrayValues(constructor, "targets");
    return targets.reduce(function(properties, targetDefinition) {
        return Object.assign(properties, $8366b7adf73549a0$var$propertiesForTargetDefinition(targetDefinition));
    }, {});
}
function $8366b7adf73549a0$var$propertiesForTargetDefinition(name) {
    var _obj;
    return _obj = {}, (0, $Npnks._)(_obj, "".concat(name, "Target"), {
        get: function() {
            var target = this.targets.find(name);
            if (target) return target;
            else throw new Error('Missing target element "'.concat(name, '" for "').concat(this.identifier, '" controller'));
        }
    }), (0, $Npnks._)(_obj, "".concat(name, "Targets"), {
        get: function() {
            return this.targets.findAll(name);
        }
    }), (0, $Npnks._)(_obj, "has".concat($8366b7adf73549a0$var$capitalize(name), "Target"), {
        get: function() {
            return this.targets.has(name);
        }
    }), _obj;
}
function $8366b7adf73549a0$var$ValuePropertiesBlessing(constructor) {
    var valueDefinitionPairs = $8366b7adf73549a0$var$readInheritableStaticObjectPairs(constructor, "values");
    var propertyDescriptorMap = {
        valueDescriptorMap: {
            get: function() {
                var _this = this;
                return valueDefinitionPairs.reduce(function(result, valueDefinitionPair) {
                    var valueDescriptor = $8366b7adf73549a0$var$parseValueDefinitionPair(valueDefinitionPair, _this.identifier);
                    var attributeName = _this.data.getAttributeNameForKey(valueDescriptor.key);
                    return Object.assign(result, (0, $Npnks._)({}, attributeName, valueDescriptor));
                }, {});
            }
        }
    };
    return valueDefinitionPairs.reduce(function(properties, valueDefinitionPair) {
        return Object.assign(properties, $8366b7adf73549a0$var$propertiesForValueDefinitionPair(valueDefinitionPair));
    }, propertyDescriptorMap);
}
function $8366b7adf73549a0$var$propertiesForValueDefinitionPair(valueDefinitionPair, controller) {
    var definition = $8366b7adf73549a0$var$parseValueDefinitionPair(valueDefinitionPair, controller);
    var key = definition.key, name = definition.name, read = definition.reader, write = definition.writer;
    var _obj;
    return _obj = {}, (0, $Npnks._)(_obj, name, {
        get: function() {
            var value = this.data.get(key);
            if (value !== null) return read(value);
            else return definition.defaultValue;
        },
        set: function(value) {
            if (value === undefined) this.data.delete(key);
            else this.data.set(key, write(value));
        }
    }), (0, $Npnks._)(_obj, "has".concat($8366b7adf73549a0$var$capitalize(name)), {
        get: function() {
            return this.data.has(key) || definition.hasCustomDefaultValue;
        }
    }), _obj;
}
function $8366b7adf73549a0$var$parseValueDefinitionPair(param, controller) {
    var _param = (0, $fyOZQ._)(param, 2), token = _param[0], typeDefinition = _param[1];
    return $8366b7adf73549a0$var$valueDescriptorForTokenAndTypeDefinition({
        controller: controller,
        token: token,
        typeDefinition: typeDefinition
    });
}
function $8366b7adf73549a0$var$parseValueTypeConstant(constant) {
    switch(constant){
        case Array:
            return "array";
        case Boolean:
            return "boolean";
        case Number:
            return "number";
        case Object:
            return "object";
        case String:
            return "string";
    }
}
function $8366b7adf73549a0$var$parseValueTypeDefault(defaultValue) {
    switch(typeof defaultValue === "undefined" ? "undefined" : (0, $jquDQ._)(defaultValue)){
        case "boolean":
            return "boolean";
        case "number":
            return "number";
        case "string":
            return "string";
    }
    if (Array.isArray(defaultValue)) return "array";
    if (Object.prototype.toString.call(defaultValue) === "[object Object]") return "object";
}
function $8366b7adf73549a0$var$parseValueTypeObject(payload) {
    var controller = payload.controller, token = payload.token, typeObject = payload.typeObject;
    var hasType = $8366b7adf73549a0$var$isSomething(typeObject.type);
    var hasDefault = $8366b7adf73549a0$var$isSomething(typeObject.default);
    var fullObject = hasType && hasDefault;
    var onlyType = hasType && !hasDefault;
    var onlyDefault = !hasType && hasDefault;
    var typeFromObject = $8366b7adf73549a0$var$parseValueTypeConstant(typeObject.type);
    var typeFromDefaultValue = $8366b7adf73549a0$var$parseValueTypeDefault(payload.typeObject.default);
    if (onlyType) return typeFromObject;
    if (onlyDefault) return typeFromDefaultValue;
    if (typeFromObject !== typeFromDefaultValue) {
        var propertyPath = controller ? "".concat(controller, ".").concat(token) : token;
        throw new Error('The specified default value for the Stimulus Value "'.concat(propertyPath, '" must match the defined type "').concat(typeFromObject, '". The provided default value of "').concat(typeObject.default, '" is of type "').concat(typeFromDefaultValue, '".'));
    }
    if (fullObject) return typeFromObject;
}
function $8366b7adf73549a0$var$parseValueTypeDefinition(payload) {
    var controller = payload.controller, token = payload.token, typeDefinition = payload.typeDefinition;
    var typeObject = {
        controller: controller,
        token: token,
        typeObject: typeDefinition
    };
    var typeFromObject = $8366b7adf73549a0$var$parseValueTypeObject(typeObject);
    var typeFromDefaultValue = $8366b7adf73549a0$var$parseValueTypeDefault(typeDefinition);
    var typeFromConstant = $8366b7adf73549a0$var$parseValueTypeConstant(typeDefinition);
    var type = typeFromObject || typeFromDefaultValue || typeFromConstant;
    if (type) return type;
    var propertyPath = controller ? "".concat(controller, ".").concat(typeDefinition) : token;
    throw new Error('Unknown value type "'.concat(propertyPath, '" for "').concat(token, '" value'));
}
function $8366b7adf73549a0$var$defaultValueForDefinition(typeDefinition) {
    var constant = $8366b7adf73549a0$var$parseValueTypeConstant(typeDefinition);
    if (constant) return $8366b7adf73549a0$var$defaultValuesByType[constant];
    var hasDefault = $8366b7adf73549a0$var$hasProperty(typeDefinition, "default");
    var hasType = $8366b7adf73549a0$var$hasProperty(typeDefinition, "type");
    var typeObject = typeDefinition;
    if (hasDefault) return typeObject.default;
    if (hasType) {
        var type = typeObject.type;
        var constantFromType = $8366b7adf73549a0$var$parseValueTypeConstant(type);
        if (constantFromType) return $8366b7adf73549a0$var$defaultValuesByType[constantFromType];
    }
    return typeDefinition;
}
function $8366b7adf73549a0$var$valueDescriptorForTokenAndTypeDefinition(payload) {
    var token = payload.token, typeDefinition = payload.typeDefinition;
    var key = "".concat($8366b7adf73549a0$var$dasherize(token), "-value");
    var type = $8366b7adf73549a0$var$parseValueTypeDefinition(payload);
    return {
        type: type,
        key: key,
        name: $8366b7adf73549a0$var$camelize(key),
        get defaultValue () {
            return $8366b7adf73549a0$var$defaultValueForDefinition(typeDefinition);
        },
        get hasCustomDefaultValue () {
            return $8366b7adf73549a0$var$parseValueTypeDefault(typeDefinition) !== undefined;
        },
        reader: $8366b7adf73549a0$var$readers[type],
        writer: $8366b7adf73549a0$var$writers[type] || $8366b7adf73549a0$var$writers.default
    };
}
var $8366b7adf73549a0$var$defaultValuesByType = {
    get array () {
        return [];
    },
    boolean: false,
    number: 0,
    get object () {
        return {};
    },
    string: ""
};
var $8366b7adf73549a0$var$readers = {
    array: function(value) {
        var array = JSON.parse(value);
        if (!Array.isArray(array)) throw new TypeError('expected value of type "array" but instead got value "'.concat(value, '" of type "').concat($8366b7adf73549a0$var$parseValueTypeDefault(array), '"'));
        return array;
    },
    boolean: function(value) {
        return !(value == "0" || String(value).toLowerCase() == "false");
    },
    number: function(value) {
        return Number(value.replace(/_/g, ""));
    },
    object: function(value) {
        var object = JSON.parse(value);
        if (object === null || typeof object != "object" || Array.isArray(object)) throw new TypeError('expected value of type "object" but instead got value "'.concat(value, '" of type "').concat($8366b7adf73549a0$var$parseValueTypeDefault(object), '"'));
        return object;
    },
    string: function(value) {
        return value;
    }
};
var $8366b7adf73549a0$var$writers = {
    default: $8366b7adf73549a0$var$writeString,
    array: $8366b7adf73549a0$var$writeJSON,
    object: $8366b7adf73549a0$var$writeJSON
};
function $8366b7adf73549a0$var$writeJSON(value) {
    return JSON.stringify(value);
}
function $8366b7adf73549a0$var$writeString(value) {
    return "".concat(value);
}
var $8366b7adf73549a0$export$bd0bf19f25da8474 = /*#__PURE__*/ function() {
    "use strict";
    function Controller(context) {
        (0, $9j09T._)(this, Controller);
        this.context = context;
    }
    (0, $eDeHT._)(Controller, [
        {
            key: "application",
            get: function get() {
                return this.context.application;
            }
        },
        {
            key: "scope",
            get: function get() {
                return this.context.scope;
            }
        },
        {
            key: "element",
            get: function get() {
                return this.scope.element;
            }
        },
        {
            key: "identifier",
            get: function get() {
                return this.scope.identifier;
            }
        },
        {
            key: "targets",
            get: function get() {
                return this.scope.targets;
            }
        },
        {
            key: "outlets",
            get: function get() {
                return this.scope.outlets;
            }
        },
        {
            key: "classes",
            get: function get() {
                return this.scope.classes;
            }
        },
        {
            key: "data",
            get: function get() {
                return this.scope.data;
            }
        },
        {
            key: "initialize",
            value: function initialize() {}
        },
        {
            key: "connect",
            value: function connect() {}
        },
        {
            key: "disconnect",
            value: function disconnect() {}
        },
        {
            key: "dispatch",
            value: function dispatch(eventName) {
                var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_target = _ref.target, target = _ref_target === void 0 ? this.element : _ref_target, _ref_detail = _ref.detail, detail = _ref_detail === void 0 ? {} : _ref_detail, _ref_prefix = _ref.prefix, prefix = _ref_prefix === void 0 ? this.identifier : _ref_prefix, _ref_bubbles = _ref.bubbles, bubbles = _ref_bubbles === void 0 ? true : _ref_bubbles, _ref_cancelable = _ref.cancelable, cancelable = _ref_cancelable === void 0 ? true : _ref_cancelable;
                var type = prefix ? "".concat(prefix, ":").concat(eventName) : eventName;
                var event = new CustomEvent(type, {
                    detail: detail,
                    bubbles: bubbles,
                    cancelable: cancelable
                });
                target.dispatchEvent(event);
                return event;
            }
        }
    ], [
        {
            key: "shouldLoad",
            get: function get() {
                return true;
            }
        },
        {
            key: "afterLoad",
            value: function afterLoad(_identifier, _application) {
                return;
            }
        }
    ]);
    return Controller;
}();
$8366b7adf73549a0$export$bd0bf19f25da8474.blessings = [
    $8366b7adf73549a0$var$ClassPropertiesBlessing,
    $8366b7adf73549a0$var$TargetPropertiesBlessing,
    $8366b7adf73549a0$var$ValuePropertiesBlessing,
    $8366b7adf73549a0$var$OutletPropertiesBlessing
];
$8366b7adf73549a0$export$bd0bf19f25da8474.targets = [];
$8366b7adf73549a0$export$bd0bf19f25da8474.outlets = [];
$8366b7adf73549a0$export$bd0bf19f25da8474.values = {};

});
parcelRegister("jpnpo", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e212828f6cfa42b8$export$7c398597f8905a1; });
function $e212828f6cfa42b8$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $e212828f6cfa42b8$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $e212828f6cfa42b8$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $e212828f6cfa42b8$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("9j09T", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6c6602e55f68dee2$export$2996f80ef42b8419; });
function $6c6602e55f68dee2$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("eDeHT", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $aa701db5d47dce88$export$d60067ff2358eee8; });
function $aa701db5d47dce88$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $aa701db5d47dce88$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $aa701db5d47dce88$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $aa701db5d47dce88$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("Npnks", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $094842b801526c9c$export$1e71eb4bef00f6b0; });
$parcel$export(module.exports, "_", function () { return $094842b801526c9c$export$1e71eb4bef00f6b0; });
function $094842b801526c9c$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("15W2b", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0cc34673f915cde4$export$afb3516d9d608401; });

var $kTflC = parcelRequire("kTflC");
function $0cc34673f915cde4$export$afb3516d9d608401(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $0cc34673f915cde4$export$afb3516d9d608401 = Reflect.get;
    else $0cc34673f915cde4$export$afb3516d9d608401 = function get(target, property, receiver) {
        var base = (0, $kTflC._super_prop_base)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $0cc34673f915cde4$export$afb3516d9d608401(target, property, receiver || target);
}

});
parcelRegister("kTflC", function(module, exports) {

$parcel$export(module.exports, "_super_prop_base", function () { return $f354d96db1b059b8$export$e4187255aefbc259; });

var $711He = parcelRequire("711He");
function $f354d96db1b059b8$export$e4187255aefbc259(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $711He._get_prototype_of)(object);
        if (object === null) break;
    }
    return object;
}

});
parcelRegister("711He", function(module, exports) {

$parcel$export(module.exports, "_get_prototype_of", function () { return $51b9f13c9445541e$export$f09211a7d3c496a1; });
$parcel$export(module.exports, "_", function () { return $51b9f13c9445541e$export$f09211a7d3c496a1; });
function $51b9f13c9445541e$export$f09211a7d3c496a1(o) {
    $51b9f13c9445541e$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $51b9f13c9445541e$export$f09211a7d3c496a1(o);
}

});



parcelRegister("i0LXg", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d1cd6ce56362f439$export$7e4530ad35d3bb8; });

var $9DCaq = parcelRequire("9DCaq");
function $d1cd6ce56362f439$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $9DCaq._set_prototype_of)(subClass, superClass);
}

});
parcelRegister("9DCaq", function(module, exports) {

$parcel$export(module.exports, "_set_prototype_of", function () { return $70455ccaac1047d2$export$c2c98ac76e997b63; });
function $70455ccaac1047d2$export$c2c98ac76e997b63(o, p) {
    $70455ccaac1047d2$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $70455ccaac1047d2$export$c2c98ac76e997b63(o, p);
}

});


parcelRegister("fyOZQ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b54196d937983a6a$export$fdf2a89c76341bbf; });

var $xoQEU = parcelRequire("xoQEU");

var $cSId0 = parcelRequire("cSId0");

var $goXgb = parcelRequire("goXgb");

var $2FuLA = parcelRequire("2FuLA");
function $b54196d937983a6a$export$fdf2a89c76341bbf(arr, i) {
    return (0, $xoQEU._array_with_holes)(arr) || (0, $cSId0._iterable_to_array_limit)(arr, i) || (0, $2FuLA._unsupported_iterable_to_array)(arr, i) || (0, $goXgb._non_iterable_rest)();
}

});
parcelRegister("xoQEU", function(module, exports) {

$parcel$export(module.exports, "_array_with_holes", function () { return $06465b8b4b6a3b50$export$e6256bf45c68d561; });
function $06465b8b4b6a3b50$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("cSId0", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array_limit", function () { return $960cd22355c3e394$export$2fd15edff6687200; });
function $960cd22355c3e394$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("goXgb", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_rest", function () { return $bf0cdb0f645955fa$export$60dbc22abd7da546; });
function $bf0cdb0f645955fa$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("2FuLA", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $1f1746ac73a3230e$export$a5be06335b3a083c; });

var $9iKib = parcelRequire("9iKib");
function $1f1746ac73a3230e$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $9iKib._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $9iKib._array_like_to_array)(o, minLen);
}

});
parcelRegister("9iKib", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $6c59b4326a243df3$export$79e617b1955a2616; });
function $6c59b4326a243df3$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("enL5v", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a787bd51e8929c56$export$1b5e630bc3aea29f; });

var $iDrRq = parcelRequire("iDrRq");

var $jEB8U = parcelRequire("jEB8U");

var $hlS7H = parcelRequire("hlS7H");

var $2FuLA = parcelRequire("2FuLA");
function $a787bd51e8929c56$export$1b5e630bc3aea29f(arr) {
    return (0, $iDrRq._array_without_holes)(arr) || (0, $jEB8U._iterable_to_array)(arr) || (0, $2FuLA._unsupported_iterable_to_array)(arr) || (0, $hlS7H._non_iterable_spread)();
}

});
parcelRegister("iDrRq", function(module, exports) {

$parcel$export(module.exports, "_array_without_holes", function () { return $d9117b172aac03e6$export$7e0947b5ad3404e2; });

var $9iKib = parcelRequire("9iKib");
function $d9117b172aac03e6$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $9iKib._array_like_to_array)(arr);
}

});

parcelRegister("jEB8U", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array", function () { return $e4ee9089a26da374$export$1eb58a6e75231000; });
function $e4ee9089a26da374$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("hlS7H", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_spread", function () { return $ca1e618e406bc232$export$e6f3c4780d19eb2b; });
function $ca1e618e406bc232$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("jquDQ", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $e24836d14c634a24$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $e24836d14c634a24$export$5f0017c582d45a2d; });
function $e24836d14c634a24$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});

parcelRegister("a1vXf", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $74c2c8e9df4e1d63$export$8dd05c13f5255580; });

var $711He = parcelRequire("711He");

var $27Mer = parcelRequire("27Mer");

var $McFnd = parcelRequire("McFnd");
function $74c2c8e9df4e1d63$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $27Mer._is_native_reflect_construct)();
    return function _createSuperInternal() {
        var Super = (0, $711He._get_prototype_of)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $711He._get_prototype_of)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $McFnd._possible_constructor_return)(this, result);
    };
}

});
parcelRegister("27Mer", function(module, exports) {

$parcel$export(module.exports, "_is_native_reflect_construct", function () { return $18c1a60db59ef4aa$export$685354647fba1516; });
function $18c1a60db59ef4aa$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("McFnd", function(module, exports) {

$parcel$export(module.exports, "_possible_constructor_return", function () { return $090e4f134975518e$export$ef97c660ca164e52; });

var $feAea = parcelRequire("feAea");

var $jquDQ = parcelRequire("jquDQ");
function $090e4f134975518e$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $jquDQ._type_of)(call) === "object" || typeof call === "function")) return call;
    return (0, $feAea._assert_this_initialized)(self);
}

});
parcelRegister("feAea", function(module, exports) {

$parcel$export(module.exports, "_assert_this_initialized", function () { return $b17443da2844f209$export$f3b8ed2e4a5d10b8; });
$parcel$export(module.exports, "_", function () { return $b17443da2844f209$export$f3b8ed2e4a5d10b8; });
function $b17443da2844f209$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("itJXR", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $d73e97026d3946cf$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__values", function () { return $d73e97026d3946cf$export$19a8beecd37a4c45; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $jquDQ = parcelRequire("jquDQ");
var $d73e97026d3946cf$var$extendStatics = function extendStatics1(d, b) {
    $d73e97026d3946cf$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $d73e97026d3946cf$var$extendStatics(d, b);
};
function $d73e97026d3946cf$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $d73e97026d3946cf$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $d73e97026d3946cf$export$18ce0697a983be9b = function __assign1() {
    $d73e97026d3946cf$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d73e97026d3946cf$export$18ce0697a983be9b.apply(this, arguments);
};
function $d73e97026d3946cf$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $d73e97026d3946cf$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $d73e97026d3946cf$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $d73e97026d3946cf$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $d73e97026d3946cf$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $d73e97026d3946cf$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $jquDQ._)(x)) === "symbol" ? x : "".concat(x);
}
function $d73e97026d3946cf$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $jquDQ._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $d73e97026d3946cf$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $d73e97026d3946cf$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $d73e97026d3946cf$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $d73e97026d3946cf$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $d73e97026d3946cf$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $d73e97026d3946cf$export$45d3717a4c69092e(o, m, p);
}
function $d73e97026d3946cf$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $d73e97026d3946cf$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $d73e97026d3946cf$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($d73e97026d3946cf$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $d73e97026d3946cf$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $d73e97026d3946cf$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $d73e97026d3946cf$export$10c90e4f7922046c(v) {
    return this instanceof $d73e97026d3946cf$export$10c90e4f7922046c ? (this.v = v, this) : new $d73e97026d3946cf$export$10c90e4f7922046c(v);
}
function $d73e97026d3946cf$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $d73e97026d3946cf$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $d73e97026d3946cf$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $d73e97026d3946cf$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $d73e97026d3946cf$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $d73e97026d3946cf$export$19a8beecd37a4c45 === "function" ? $d73e97026d3946cf$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $d73e97026d3946cf$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $d73e97026d3946cf$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $d73e97026d3946cf$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d73e97026d3946cf$export$45d3717a4c69092e(result, mod, k);
    }
    $d73e97026d3946cf$var$__setModuleDefault(result, mod);
    return result;
}
function $d73e97026d3946cf$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $d73e97026d3946cf$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $d73e97026d3946cf$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $d73e97026d3946cf$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $d73e97026d3946cf$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $d73e97026d3946cf$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $d73e97026d3946cf$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $d73e97026d3946cf$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $d73e97026d3946cf$export$2e2bcd8739ae039 = {
    __extends: $d73e97026d3946cf$export$a8ba968b8961cb8a,
    __assign: $d73e97026d3946cf$export$18ce0697a983be9b,
    __rest: $d73e97026d3946cf$export$3c9a16f847548506,
    __decorate: $d73e97026d3946cf$export$29e00dfd3077644b,
    __param: $d73e97026d3946cf$export$d5ad3fd78186038f,
    __metadata: $d73e97026d3946cf$export$f1db080c865becb9,
    __awaiter: $d73e97026d3946cf$export$1050f835b63b671e,
    __generator: $d73e97026d3946cf$export$67ebef60e6f28a6,
    __createBinding: $d73e97026d3946cf$export$45d3717a4c69092e,
    __exportStar: $d73e97026d3946cf$export$f33643c0debef087,
    __values: $d73e97026d3946cf$export$19a8beecd37a4c45,
    __read: $d73e97026d3946cf$export$8d051b38c9118094,
    __spread: $d73e97026d3946cf$export$afc72e2116322959,
    __spreadArrays: $d73e97026d3946cf$export$6388937ca91ccae8,
    __spreadArray: $d73e97026d3946cf$export$1216008129fb82ed,
    __await: $d73e97026d3946cf$export$10c90e4f7922046c,
    __asyncGenerator: $d73e97026d3946cf$export$e427f37a30a4de9b,
    __asyncDelegator: $d73e97026d3946cf$export$bbd80228419bb833,
    __asyncValues: $d73e97026d3946cf$export$e3b29a3d6162315f,
    __makeTemplateObject: $d73e97026d3946cf$export$4fb47efe1390b86f,
    __importStar: $d73e97026d3946cf$export$c21735bcef00d192,
    __importDefault: $d73e97026d3946cf$export$da59b14a69baef04,
    __classPrivateFieldGet: $d73e97026d3946cf$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $d73e97026d3946cf$export$d40a35129aaff81f,
    __classPrivateFieldIn: $d73e97026d3946cf$export$81fdc39f203e4e04,
    __addDisposableResource: $d73e97026d3946cf$export$88ac25d8e944e405,
    __disposeResources: $d73e97026d3946cf$export$8f076105dc360e92
};

});


})();
//# sourceMappingURL=stimulus-classic.5a6589e7.js.map
